:root {
  --xpl-size-spacing-144: 8.75rem;
  --xpl-size-spacing-112: 7rem;
  --xpl-size-spacing-80: 5rem;
  --xpl-size-spacing-64: 4rem;
  --xpl-size-spacing-48: 3rem;
  --xpl-size-spacing-32: 2rem;
  --xpl-size-spacing-24: 1.5rem;
  --xpl-size-spacing-16: 1rem;
  --xpl-size-spacing-12: 0.75rem;
  --xpl-size-spacing-8: 0.5rem;
  --xpl-size-spacing-4: 0.25rem;
  --xpl-size-spacing-0: 0rem;
  --xpl-size-font-caption: 0.75rem;
  --xpl-size-font-callout: 0.75rem;
  --xpl-size-font-body: 0.875rem;
  --xpl-size-font-title-5: 0.875rem;
  --xpl-size-font-title-4: 1rem;
  --xpl-size-font-title-3: 1.25rem;
  --xpl-size-font-title-2: 1.5rem;
  --xpl-size-font-title-1: 1.875rem;
  --xpl-font-weight-normal: normal;
  --xpl-font-weight-medium: medium;
  --xpl-font-weight-bold: bold;
  --xpl-font-family-default: apple-system, system-ui, 'Segoe UI', Arial, Helvetica, Roboto, sans-serif;
  --xpl-color-transparent: rgba(255, 255, 255, 0);
  --xpl-color-red-900: #731409;
  --xpl-color-red-800: #961305;
  --xpl-color-red-700: #c2210f;
  --xpl-color-red-600: #db321f;
  --xpl-color-red-500: #f24f3d;
  --xpl-color-red-400: #f87263;
  --xpl-color-red-300: #ff9387;
  --xpl-color-red-200: #fec5be;
  --xpl-color-red-100: #fed9d5;
  --xpl-color-red-50: #fef7f3;
  --xpl-color-pink-900: #730b3f;
  --xpl-color-pink-800: #990f54;
  --xpl-color-pink-700: #bf1d7b;
  --xpl-color-pink-600: #cc3399;
  --xpl-color-pink-500: #e550c8;
  --xpl-color-pink-400: #f26ddc;
  --xpl-color-pink-300: #ff8df4;
  --xpl-color-pink-200: #ffb8f9;
  --xpl-color-pink-100: #ffd9fb;
  --xpl-color-pink-50: #fff0fe;
  --xpl-color-yellow-900: #5c5002;
  --xpl-color-yellow-800: #726916;
  --xpl-color-yellow-700: #8a8220;
  --xpl-color-yellow-600: #9e9828;
  --xpl-color-yellow-500: #adab20;
  --xpl-color-yellow-400: #c6cc4e;
  --xpl-color-yellow-300: #dce967;
  --xpl-color-yellow-200: #ecfd91;
  --xpl-color-yellow-100: #f3febb;
  --xpl-color-yellow-50: #fbffe5;
  --xpl-color-green-900: #154737;
  --xpl-color-green-800: #1d614b;
  --xpl-color-green-700: #24785d;
  --xpl-color-green-600: #2e9977;
  --xpl-color-green-500: #37b88f;
  --xpl-color-green-400: #4ad4a8;
  --xpl-color-green-300: #52ebba;
  --xpl-color-green-200: #74fbd0;
  --xpl-color-green-100: #c4ffed;
  --xpl-color-green-50: #ebfff8;
  --xpl-color-orange-900: #7a2714;
  --xpl-color-orange-800: #a6361a;
  --xpl-color-orange-700: #cc4121;
  --xpl-color-orange-600: #f44e27;
  --xpl-color-orange-500: #f76d43;
  --xpl-color-orange-400: #f99170;
  --xpl-color-orange-300: #ffbda8;
  --xpl-color-orange-200: #ffdccc;
  --xpl-color-orange-100: #feede4;
  --xpl-color-orange-50: #fef6f4;
  --xpl-color-purple-900: #330d80;
  --xpl-color-purple-800: #4d1ab2;
  --xpl-color-purple-700: #6923f4;
  --xpl-color-purple-600: #793ef7;
  --xpl-color-purple-500: #8857fa;
  --xpl-color-purple-400: #a480ff;
  --xpl-color-purple-300: #c3adff;
  --xpl-color-purple-200: #ddd1ff;
  --xpl-color-purple-100: #ebe5ff;
  --xpl-color-purple-50: #f4f2ff;
  --xpl-color-gray-1200: #18161f;
  --xpl-color-gray-1100: #201e29;
  --xpl-color-gray-1000: #292632;
  --xpl-color-gray-900: #302d3b;
  --xpl-color-gray-800: #363240;
  --xpl-color-gray-700: #3c3847;
  --xpl-color-gray-600: #6a6d7d;
  --xpl-color-gray-500: #999ba8;
  --xpl-color-gray-400: #e1e2e8;
  --xpl-color-gray-300: #eaebef;
  --xpl-color-gray-200: #eeeff3;
  --xpl-color-gray-100: #f3f4f6;
  --xpl-color-gray-50: #f8f9fa;
  --xpl-color-gray-0: #ffffff;
  --xpl-color-text-warning-dm: var(--xpl-color-red-300);
  --xpl-color-text-warning-lm: var(--xpl-color-red-700);
  --xpl-color-text-reverse-dm: var(--xpl-color-gray-1000);
  --xpl-color-text-reverse-lm: var(--xpl-color-gray-0);
  --xpl-color-text-secondary-dm: var(--xpl-color-gray-500);
  --xpl-color-text-secondary-lm: var(--xpl-color-gray-600);
  --xpl-color-text-primary-dm: var(--xpl-color-gray-0);
  --xpl-color-text-primary-lm: var(--xpl-color-gray-900);
  --xpl-color-action-warning-hover-dm: var(--xpl-color-red-400);
  --xpl-color-action-warning-hover-lm: var(--xpl-color-red-800);
  --xpl-color-action-warning-dm: var(--xpl-color-red-300);
  --xpl-color-action-warning-lm: var(--xpl-color-red-700);
  --xpl-color-action-disabled-dm: var(--xpl-color-gray-800);
  --xpl-color-action-disabled-lm: var(--xpl-color-gray-100);
  --xpl-color-action-primary-hover-dm: var(--xpl-color-purple-400);
  --xpl-color-action-primary-hover-lm: var(--xpl-color-purple-800);
  --xpl-color-action-primary-dm: var(--xpl-color-purple-300);
  --xpl-color-action-primary-lm: var(--xpl-color-purple-700);
  --xpl-color-trivial-bg-dm: var(--xpl-color-transparent);
  --xpl-color-trivial-bg-lm: var(--xpl-color-gray-400);
  --xpl-color-trivial-dm: var(--xpl-color-gray-500);
  --xpl-color-trivial-lm: var(--xpl-color-gray-600);
  --xpl-color-information-bg-dm: var(--xpl-color-transparent);
  --xpl-color-highlight-bg-dm: var(--xpl-color-transparent);
  --xpl-color-highlight-bg-lm: var(--xpl-color-yellow-200);
  --xpl-color-highlight-dm: var(--xpl-color-yellow-200);
  --xpl-color-highlight-lm: var(--xpl-color-yellow-500);
  --xpl-color-negative-bg-dm: var(--xpl-color-transparent);
  --xpl-color-negative-bg-lm: var(--xpl-color-red-100);
  --xpl-color-negative-dm: var(--xpl-color-red-300);
  --xpl-color-negative-lm: var(--xpl-color-red-600);
  --xpl-color-positive-bg-dm: var(--xpl-color-transparent);
  --xpl-color-positive-bg-lm: var(--xpl-color-green-100);
  --xpl-color-positive-dm: var(--xpl-color-green-300);
  --xpl-color-positive-lm: var(--xpl-color-green-500);
  --xpl-color-secondary-bg-dm: var(--xpl-color-gray-900); /* themable */
  --xpl-color-secondary-bg-lm: var(--xpl-color-purple-50); /* themable */
  --xpl-color-secondary-hover-dm: var(--xpl-color-purple-400); /* themable */
  --xpl-color-secondary-hover-lm: var(--xpl-color-purple-800); /* themable */
  --xpl-color-secondary-dm: var(--xpl-color-purple-300); /* themable */
  --xpl-color-secondary-lm: var(--xpl-color-purple-700); /* themable */
  --xpl-color-primary-bg-dm: var(--xpl-color-gray-900); /* themable */
  --xpl-color-primary-bg-lm: var(--xpl-color-orange-50); /* themable */
  --xpl-color-primary-dm: var(--xpl-color-orange-400); /* themable */
  --xpl-color-primary-lm: var(--xpl-color-orange-600); /* themable */
  --xpl-color-stroke-dm: var(--xpl-color-gray-700);
  --xpl-color-stroke-lm: var(--xpl-color-gray-400);
  --xpl-color-navigation-dm: var(--xpl-color-gray-1000);
  --xpl-color-navigation-lm: var(--xpl-color-gray-1000);
  --xpl-color-background-2-dm: var(--xpl-color-gray-1100);
  --xpl-color-background-2-lm: var(--xpl-color-gray-100);
  --xpl-color-background-dm: var(--xpl-color-gray-1200);
  --xpl-color-background-lm: var(--xpl-color-gray-50);
  --xpl-color-foreground-dm: var(--xpl-color-gray-1000);
  --xpl-color-foreground-lm: var(--xpl-color-gray-0);
  --xpl-color-accent-purple: var(--xpl-color-purple-300);
  --xpl-color-accent-pink: var(--xpl-color-pink-300);
  --xpl-color-accent-yellow: var(--xpl-color-yellow-200);
  --xpl-color-accent-green: var(--xpl-color-green-200);
  --xpl-color-text-action-dm: var(--xpl-color-primary-dm); /* uses themable token */
  --xpl-color-text-action-lm: var(--xpl-color-primary-lm); /* uses themable token */
  --xpl-color-information-bg-lm: var(--xpl-color-primary-bg-lm); /* uses themable token */
  --xpl-color-information-dm: var(--xpl-color-primary-dm); /* uses themable token */
  --xpl-color-information-lm: var(--xpl-color-primary-lm); /* uses themable token */
}
.flatpickr-calendar{background:transparent;opacity:0;display:none;text-align:center;visibility:hidden;padding:0;animation:none;direction:ltr;border:0;font-size:0.875rem;line-height:1.5rem;border-radius:5px;position:absolute;width:307.875px;box-sizing:border-box;touch-action:manipulation;background:#fff;box-shadow:1px 0 0 #e6e6e6,-1px 0 0 #e6e6e6,0 1px 0 #e6e6e6,0 -1px 0 #e6e6e6,0 3px 13px rgba(0,0,0,0.08)}
.flatpickr-calendar.open,.flatpickr-calendar.inline{opacity:1;max-height:640px;visibility:visible}
.flatpickr-calendar.open{display:inline-block;z-index:99999}
.flatpickr-calendar.animate.open{animation:fpFadeInDown 300ms cubic-bezier(.23,1,.32,1)}
.flatpickr-calendar.inline{display:block;position:relative;top:2px}
.flatpickr-calendar.static{position:absolute;top:calc(100% + 2px)}
.flatpickr-calendar.static.open{z-index:999;display:block}
.flatpickr-calendar.multiMonth .flatpickr-days .dayContainer:nth-child(n+1) .flatpickr-day.inRange:nth-child(7n+7){box-shadow:none !important}
.flatpickr-calendar.multiMonth .flatpickr-days .dayContainer:nth-child(n+2) .flatpickr-day.inRange:nth-child(7n+1){box-shadow:-2px 0 0 #e6e6e6,5px 0 0 #e6e6e6}
.flatpickr-calendar .hasWeeks .dayContainer,.flatpickr-calendar .hasTime .dayContainer{border-bottom:0;border-bottom-right-radius:0;border-bottom-left-radius:0}
.flatpickr-calendar .hasWeeks .dayContainer{border-left:0}
.flatpickr-calendar.hasTime .flatpickr-time{height:40px;border-top:1px solid #e6e6e6}
.flatpickr-calendar.noCalendar.hasTime .flatpickr-time{height:auto}
.flatpickr-calendar:before,.flatpickr-calendar:after{position:absolute;display:block;pointer-events:none;border:solid transparent;content:'';height:0;width:0;left:22px}
.flatpickr-calendar.rightMost:before,.flatpickr-calendar.arrowRight:before,.flatpickr-calendar.rightMost:after,.flatpickr-calendar.arrowRight:after{left:auto;right:22px}
.flatpickr-calendar.arrowCenter:before,.flatpickr-calendar.arrowCenter:after{left:50%;right:50%}
.flatpickr-calendar:before{border-width:5px;margin:0 -5px}
.flatpickr-calendar:after{border-width:4px;margin:0 -4px}
.flatpickr-calendar.arrowTop:before,.flatpickr-calendar.arrowTop:after{bottom:100%}
.flatpickr-calendar.arrowTop:before{border-bottom-color:#e6e6e6}
.flatpickr-calendar.arrowTop:after{border-bottom-color:#fff}
.flatpickr-calendar.arrowBottom:before,.flatpickr-calendar.arrowBottom:after{top:100%}
.flatpickr-calendar.arrowBottom:before{border-top-color:#e6e6e6}
.flatpickr-calendar.arrowBottom:after{border-top-color:#fff}
.flatpickr-calendar:focus{outline:0}
.flatpickr-wrapper{position:relative;display:inline-block}
.flatpickr-months{display:flex}
.flatpickr-months .flatpickr-month{background:transparent;color:rgba(0,0,0,0.9);fill:rgba(0,0,0,0.9);height:34px;line-height:1;text-align:center;position:relative;-webkit-user-select:none;-moz-user-select:none;user-select:none;overflow:hidden;flex:1}
.flatpickr-months .flatpickr-prev-month,.flatpickr-months .flatpickr-next-month{-webkit-user-select:none;-moz-user-select:none;user-select:none;text-decoration:none;cursor:pointer;position:absolute;top:0;height:34px;padding:10px;z-index:3;color:rgba(0,0,0,0.9);fill:rgba(0,0,0,0.9)}
.flatpickr-months .flatpickr-prev-month.flatpickr-disabled,.flatpickr-months .flatpickr-next-month.flatpickr-disabled{display:none}
.flatpickr-months .flatpickr-prev-month i,.flatpickr-months .flatpickr-next-month i{position:relative}
.flatpickr-months .flatpickr-prev-month.flatpickr-prev-month,.flatpickr-months .flatpickr-next-month.flatpickr-prev-month{/*
      /*rtl:begin:ignore*/left:0/*
      /*rtl:end:ignore*/}
/*
      /*rtl:begin:ignore*/
/*
      /*rtl:end:ignore*/
.flatpickr-months .flatpickr-prev-month.flatpickr-next-month,.flatpickr-months .flatpickr-next-month.flatpickr-next-month{/*
      /*rtl:begin:ignore*/right:0/*
      /*rtl:end:ignore*/}
/*
      /*rtl:begin:ignore*/
/*
      /*rtl:end:ignore*/
.flatpickr-months .flatpickr-prev-month:hover,.flatpickr-months .flatpickr-next-month:hover{color:#959ea9}
.flatpickr-months .flatpickr-prev-month:hover svg,.flatpickr-months .flatpickr-next-month:hover svg{fill:#f64747}
.flatpickr-months .flatpickr-prev-month svg,.flatpickr-months .flatpickr-next-month svg{width:14px;height:14px}
.flatpickr-months .flatpickr-prev-month svg path,.flatpickr-months .flatpickr-next-month svg path{transition:fill .1s;fill:inherit}
.numInputWrapper{position:relative;height:auto}
.numInputWrapper input,.numInputWrapper span{display:inline-block}
.numInputWrapper input{width:100%}
.numInputWrapper input::-ms-clear{display:none}
.numInputWrapper input::-webkit-outer-spin-button,.numInputWrapper input::-webkit-inner-spin-button{margin:0;-webkit-appearance:none}
.numInputWrapper span{position:absolute;right:0;width:14px;padding:0 4px 0 2px;height:50%;line-height:50%;opacity:0;cursor:pointer;border:1px solid rgba(57,57,57,0.15);box-sizing:border-box}
.numInputWrapper span:hover{background:rgba(0,0,0,0.1)}
.numInputWrapper span:active{background:rgba(0,0,0,0.2)}
.numInputWrapper span:after{display:block;content:"";position:absolute}
.numInputWrapper span.arrowUp{top:0;border-bottom:0}
.numInputWrapper span.arrowUp:after{border-left:4px solid transparent;border-right:4px solid transparent;border-bottom:4px solid rgba(57,57,57,0.6);top:26%}
.numInputWrapper span.arrowDown{top:50%}
.numInputWrapper span.arrowDown:after{border-left:4px solid transparent;border-right:4px solid transparent;border-top:4px solid rgba(57,57,57,0.6);top:40%}
.numInputWrapper span svg{width:inherit;height:auto}
.numInputWrapper span svg path{fill:rgba(0,0,0,0.5)}
.numInputWrapper:hover{background:rgba(0,0,0,0.05)}
.numInputWrapper:hover span{opacity:1}
.flatpickr-current-month{font-size:135%;line-height:inherit;font-weight:300;color:inherit;position:absolute;width:75%;left:12.5%;padding:7.48px 0 0 0;line-height:1;height:34px;display:inline-block;text-align:center;transform:translate3d(0,0,0)}
.flatpickr-current-month span.cur-month{font-family:inherit;font-weight:700;color:inherit;display:inline-block;margin-left:.5ch;padding:0}
.flatpickr-current-month span.cur-month:hover{background:rgba(0,0,0,0.05)}
.flatpickr-current-month .numInputWrapper{width:6ch;width:7ch\0;display:inline-block}
.flatpickr-current-month .numInputWrapper span.arrowUp:after{border-bottom-color:rgba(0,0,0,0.9)}
.flatpickr-current-month .numInputWrapper span.arrowDown:after{border-top-color:rgba(0,0,0,0.9)}
.flatpickr-current-month input.cur-year{background:transparent;box-sizing:border-box;color:inherit;cursor:text;padding:0 0 0 .5ch;margin:0;display:inline-block;font-size:inherit;font-family:inherit;font-weight:300;line-height:inherit;height:auto;border:0;border-radius:0;vertical-align:initial;-webkit-appearance:textfield;-moz-appearance:textfield;appearance:textfield}
.flatpickr-current-month input.cur-year:focus{outline:0}
.flatpickr-current-month input.cur-year[disabled],.flatpickr-current-month input.cur-year[disabled]:hover{font-size:100%;color:rgba(0,0,0,0.5);background:transparent;pointer-events:none}
.flatpickr-current-month .flatpickr-monthDropdown-months{appearance:menulist;background:transparent;border:none;border-radius:0;box-sizing:border-box;color:inherit;cursor:pointer;font-size:inherit;font-family:inherit;font-weight:300;height:auto;line-height:inherit;margin:-1px 0 0 0;outline:none;padding:0 0 0 .5ch;position:relative;vertical-align:initial;-webkit-box-sizing:border-box;-webkit-appearance:menulist;-moz-appearance:menulist;width:auto}
.flatpickr-current-month .flatpickr-monthDropdown-months:focus,.flatpickr-current-month .flatpickr-monthDropdown-months:active{outline:none}
.flatpickr-current-month .flatpickr-monthDropdown-months:hover{background:rgba(0,0,0,0.05)}
.flatpickr-current-month .flatpickr-monthDropdown-months .flatpickr-monthDropdown-month{background-color:transparent;outline:none;padding:0}
.flatpickr-weekdays{background:transparent;text-align:center;overflow:hidden;width:100%;display:flex;align-items:center;height:28px}
.flatpickr-weekdays .flatpickr-weekdaycontainer{display:flex;flex:1}
span.flatpickr-weekday{cursor:default;font-size:90%;background:transparent;color:rgba(0,0,0,0.54);line-height:1;margin:0;text-align:center;display:block;flex:1;font-weight:bolder}
.dayContainer,.flatpickr-weeks{padding:1px 0 0 0}
.flatpickr-days{position:relative;overflow:hidden;display:flex;align-items:flex-start;width:307.875px}
.flatpickr-days:focus{outline:0}
.dayContainer{padding:0;outline:0;text-align:left;width:307.875px;min-width:307.875px;max-width:307.875px;box-sizing:border-box;display:inline-block;display:flex;flex-wrap:wrap;-ms-flex-wrap:wrap;justify-content:space-around;transform:translate3d(0,0,0);opacity:1}
.dayContainer + .dayContainer{box-shadow:-1px 0 0 #e6e6e6}
.flatpickr-day{background:none;border:1px solid transparent;border-radius:150px;box-sizing:border-box;color:#393939;cursor:pointer;font-weight:400;width:14.2857143%;flex-basis:14.2857143%;max-width:39px;height:39px;line-height:2.4375rem;margin:0;display:inline-block;position:relative;justify-content:center;text-align:center}
.flatpickr-day.inRange,.flatpickr-day.prevMonthDay.inRange,.flatpickr-day.nextMonthDay.inRange,.flatpickr-day.today.inRange,.flatpickr-day.prevMonthDay.today.inRange,.flatpickr-day.nextMonthDay.today.inRange,.flatpickr-day:hover,.flatpickr-day.prevMonthDay:hover,.flatpickr-day.nextMonthDay:hover,.flatpickr-day:focus,.flatpickr-day.prevMonthDay:focus,.flatpickr-day.nextMonthDay:focus{cursor:pointer;outline:0;background:#e6e6e6;border-color:#e6e6e6}
.flatpickr-day.today{border-color:#959ea9}
.flatpickr-day.today:hover,.flatpickr-day.today:focus{border-color:#959ea9;background:#959ea9;color:#fff}
.flatpickr-day.selected,.flatpickr-day.startRange,.flatpickr-day.endRange,.flatpickr-day.selected.inRange,.flatpickr-day.startRange.inRange,.flatpickr-day.endRange.inRange,.flatpickr-day.selected:focus,.flatpickr-day.startRange:focus,.flatpickr-day.endRange:focus,.flatpickr-day.selected:hover,.flatpickr-day.startRange:hover,.flatpickr-day.endRange:hover,.flatpickr-day.selected.prevMonthDay,.flatpickr-day.startRange.prevMonthDay,.flatpickr-day.endRange.prevMonthDay,.flatpickr-day.selected.nextMonthDay,.flatpickr-day.startRange.nextMonthDay,.flatpickr-day.endRange.nextMonthDay{background:#569ff7;box-shadow:none;color:#fff;border-color:#569ff7}
.flatpickr-day.selected.startRange,.flatpickr-day.startRange.startRange,.flatpickr-day.endRange.startRange{border-radius:50px 0 0 50px}
.flatpickr-day.selected.endRange,.flatpickr-day.startRange.endRange,.flatpickr-day.endRange.endRange{border-radius:0 50px 50px 0}
.flatpickr-day.selected.startRange + .endRange:not(:nth-child(7n+1)),.flatpickr-day.startRange.startRange + .endRange:not(:nth-child(7n+1)),.flatpickr-day.endRange.startRange + .endRange:not(:nth-child(7n+1)){box-shadow:-10px 0 0 #569ff7}
.flatpickr-day.selected.startRange.endRange,.flatpickr-day.startRange.startRange.endRange,.flatpickr-day.endRange.startRange.endRange{border-radius:50px}
.flatpickr-day.inRange{border-radius:0;box-shadow:-5px 0 0 #e6e6e6,5px 0 0 #e6e6e6}
.flatpickr-day.flatpickr-disabled,.flatpickr-day.flatpickr-disabled:hover,.flatpickr-day.prevMonthDay,.flatpickr-day.nextMonthDay,.flatpickr-day.notAllowed,.flatpickr-day.notAllowed.prevMonthDay,.flatpickr-day.notAllowed.nextMonthDay{color:rgba(57,57,57,0.3);background:transparent;border-color:transparent;cursor:default}
.flatpickr-day.flatpickr-disabled,.flatpickr-day.flatpickr-disabled:hover{cursor:not-allowed;color:rgba(57,57,57,0.1)}
.flatpickr-day.week.selected{border-radius:0;box-shadow:-5px 0 0 #569ff7,5px 0 0 #569ff7}
.flatpickr-day.hidden{visibility:hidden}
.rangeMode .flatpickr-day{margin-top:1px}
.flatpickr-weekwrapper{float:left}
.flatpickr-weekwrapper .flatpickr-weeks{padding:0 12px;box-shadow:1px 0 0 #e6e6e6}
.flatpickr-weekwrapper .flatpickr-weekday{float:none;width:100%;line-height:1.75rem}
.flatpickr-weekwrapper span.flatpickr-day,.flatpickr-weekwrapper span.flatpickr-day:hover{display:block;width:100%;max-width:none;color:rgba(57,57,57,0.3);background:transparent;cursor:default;border:none}
.flatpickr-innerContainer{display:block;display:flex;box-sizing:border-box;overflow:hidden}
.flatpickr-rContainer{display:inline-block;padding:0;box-sizing:border-box}
.flatpickr-time{text-align:center;outline:0;display:block;height:0;line-height:2.5rem;max-height:40px;box-sizing:border-box;overflow:hidden;display:flex}
.flatpickr-time:after{content:"";display:table;clear:both}
.flatpickr-time .numInputWrapper{flex:1;width:40%;height:40px;float:left}
.flatpickr-time .numInputWrapper span.arrowUp:after{border-bottom-color:#393939}
.flatpickr-time .numInputWrapper span.arrowDown:after{border-top-color:#393939}
.flatpickr-time.hasSeconds .numInputWrapper{width:26%}
.flatpickr-time.time24hr .numInputWrapper{width:49%}
.flatpickr-time input{background:transparent;box-shadow:none;border:0;border-radius:0;text-align:center;margin:0;padding:0;height:inherit;line-height:inherit;color:#393939;font-size:0.875rem;position:relative;box-sizing:border-box;-webkit-appearance:textfield;-moz-appearance:textfield;appearance:textfield}
.flatpickr-time input.flatpickr-hour{font-weight:bold}
.flatpickr-time input.flatpickr-minute,.flatpickr-time input.flatpickr-second{font-weight:400}
.flatpickr-time input:focus{outline:0;border:0}
.flatpickr-time .flatpickr-time-separator,.flatpickr-time .flatpickr-am-pm{height:inherit;float:left;line-height:inherit;color:#393939;font-weight:bold;width:2%;-webkit-user-select:none;-moz-user-select:none;user-select:none;align-self:center}
.flatpickr-time .flatpickr-am-pm{outline:0;width:18%;cursor:pointer;text-align:center;font-weight:400}
.flatpickr-time input:hover,.flatpickr-time .flatpickr-am-pm:hover,.flatpickr-time input:focus,.flatpickr-time .flatpickr-am-pm:focus{background:#eee}
.flatpickr-input[readonly]{cursor:pointer}
@keyframes fpFadeInDown{from{opacity:0;transform:translate3d(0,-20px,0)}to{opacity:1;transform:translate3d(0,0,0)}}
/* stylelint-disable no-descending-specificity  */
/*! tailwindcss v2.1.4 | MIT License | https://tailwindcss.com */
/*! modern-normalize v1.1.0 | MIT License | https://github.com/sindresorhus/modern-normalize */
/*
Document
========
*/
/**
 * 1. Prevent padding and border from affecting element width.
 *
 *    We used to set this in the html element and inherit from
 *    the parent element for everything else. This caused issues
 *    in shadow-dom-enhanced elements like <details> where the content
 *    is wrapped by a div with box-sizing set to `content-box`.
 *
 *    https://github.com/mozdevs/cssremedy/issues/4
 *
 *
 * 2. Allow adding a border to an element by just adding a border-width.
 *
 *    By default, the way the browser specifies that an element should have no
 *    border is by setting it's border-style to `none` in the user-agent
 *    stylesheet.
 *
 *    In order to easily add borders to elements by just setting the `border-width`
 *    property, we change the default border-style for all elements to `solid`, and
 *    use border-width to hide them instead. This way our `border` utilities only
 *    need to set the `border-width` property instead of the entire `border`
 *    shorthand, making our border utilities much more straightforward to compose.
 *
 *    https://github.com/tailwindcss/tailwindcss/pull/116
 */
[class^="xpl-"],
[class^="xpl-"] *,
[class^="xpl-"]::before,
[class^="xpl-"] *::before,
[class^="xpl-"]::after,
[class^="xpl-"] *::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}
/**
Use a more readable tab size (opinionated).
*/
/**
1. Correct the line height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
*/
[class^="xpl-"] {
  -moz-tab-size: 4;
  -o-tab-size: 4;
  tab-size: 4;
  line-height: 1.15; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
}
/*
Sections
========
*/
/**
Improve consistency of default fonts in all browsers. (https://github.com/sindresorhus/modern-normalize/issues/3)
*/
/**
 * Tailwind custom reset styles
 */
/**
 * 1. Use the user's configured `sans` font-family (with Tailwind's default
 *    sans-serif font stack as a fallback) as a sane default.
 * 2. Use Tailwind's default "normal" line-height so the user isn't forced
 *    to override it to ensure consistency even when using the default theme.
 */
[class^="xpl-"],
[class^="xpl-"] * {
  font-family: var(--xpl-font-family-default);
  line-height: 1.5; /* 2 */
}
/*
Grouping content
================
*/
/**
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default
*/
[class^="xpl-"] hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}
/*
Text-level semantics
====================
*/
/**
Add the correct text decoration in Chrome, Edge, and Safari.
*/
/**
Add the correct font weight in Edge and Safari.
*/
[class^="xpl-"] b,
[class^="xpl-"] strong {
  font-weight: bolder;
}
/**
1. Improve consistency of default fonts in all browsers. (https://github.com/sindresorhus/modern-normalize/issues/3)
2. Correct the odd 'em' font sizing in all browsers.
*/
/**
 * Use the configured 'mono' font family for elements that
 * are expected to be rendered with a monospace font, falling
 * back to the system monospace stack if there is no configured
 * 'mono' font family.
 */
[class^="xpl-"] pre,
[class^="xpl-"] code,
[class^="xpl-"] kbd,
[class^="xpl-"] samp {
  font-family:
    ui-monospace,
    SFMono-Regular,
    Menlo,
    Monaco,
    Consolas,
    "Liberation Mono",
    "Courier New",
    monospace; /* 1 */

  font-size: 1em; /* 2 */
}
/**
Add the correct font size in all browsers.
*/
[class^="xpl-"] small {
  font-size: 80%;
}
/**
Prevent 'sub' and 'sup' elements from affecting the line height in all browsers.
*/
[class^="xpl-"] sub,
[class^="xpl-"] sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}
[class^="xpl-"] sub {
  bottom: -0.25em;
}
[class^="xpl-"] sup {
  top: -0.5em;
}
/*
Tabular data
============
*/
/**
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
*/
[class^="xpl-"] table,
table[class^="xpl-"] {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse;
}
/*
Forms
=====
*/
/**
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
*/
[class^="xpl-"] button,
button[class^="xpl-"],
[class^="xpl-"] input,
input[class^="xpl-"],
[class^="xpl-"] optgroup,
optgroup[class^="xpl-"],
[class^="xpl-"] select,
select[class^="xpl-"] [class^="xpl-"] textarea,
textarea[class^="xpl-"] {
  font-family: var(--xpl-font-family-default); /* 1 */
  font-size: 100%; /* 1 */
  line-height: 1.15; /* 1 */
  margin: 0; /* 2 */
}
/**
Remove the inheritance of text transform in Edge and Firefox.
1. Remove the inheritance of text transform in Firefox.
*/
[class^="xpl-"] button,
button[class^="xpl-"],
[class^="xpl-"] select,
select[class^="xpl-"] {
  /* 1 */
  text-transform: none;
}
/**
Correct the inability to style clickable types in iOS and Safari.
*/
[class^="xpl-"] button,
button[class^="xpl-"] [class^="xpl-"] [type="button"],
[type="button"][class^="xpl-"] {
  -webkit-appearance: none;
}
/**
Remove the padding so developers are not caught out when they zero out 'fieldset' elements in all browsers.
*/
[class^="xpl-"] legend {
  padding: 0;
}
/**
Add the correct vertical alignment in Chrome and Firefox.
*/
[class^="xpl-"] progress {
  vertical-align: baseline;
}
/*
Interactive
===========
*/
/*
Add the correct display in Chrome and Safari.
*/
[class^="xpl-"] summary {
  display: list-item;
}
[class^="xpl-"] button,
button[class^="xpl-"] {
  background-color: transparent;
  background-image: none;
  cursor: pointer;
}
/**
 * Work around a Firefox/IE bug where the transparent `button` background
 * results in a loss of the default `button` focus styles.
 */
[class^="xpl-"] button:focus,
button[class^="xpl-"]:focus {
  outline: 1px dotted;
  outline: 5px auto -webkit-focus-ring-color;
}
[class^="xpl-"] fieldset {
  margin: 0;
  padding: 0;
}
[class^="xpl-"] ol,
ol[class^="xpl-"],
[class^="xpl-"] ul,
ul[class^="xpl-"] {
  list-style: none;
  margin: 0;
  padding: 0;
}
/**
 * Undo the `border-style: none` reset that Normalize applies to images so that
 * our `border-{width}` utilities have the expected effect.
 *
 * The Normalize reset is unnecessary for us since we default the border-width
 * to 0 on all elements.
 *
 * https://github.com/tailwindcss/tailwindcss/issues/362
 */
[class^="xpl-"] img {
  border-style: solid;
}
[class^="xpl-"] textarea {
  resize: vertical;
}
[class^="xpl-"] input::-moz-placeholder,
input[class^="xpl-"]::-moz-placeholder,
[class^="xpl-"] textarea::-moz-placeholder,
textarea[class^="xpl-"]::-moz-placeholder {
  opacity: 1;
  color: #9ca3af;
}
[class^="xpl-"] input::-moz-placeholder, input[class^="xpl-"]::-moz-placeholder, [class^="xpl-"] textarea::-moz-placeholder, textarea[class^="xpl-"]::-moz-placeholder {
  opacity: 1;
  color: #9ca3af;
}
[class^="xpl-"] input::placeholder,
input[class^="xpl-"]::placeholder,
[class^="xpl-"] textarea::placeholder,
textarea[class^="xpl-"]::placeholder {
  opacity: 1;
  color: #9ca3af;
}
[class^="xpl-"] h1,
[class^="xpl-"] h2,
[class^="xpl-"] h3,
[class^="xpl-"] h4,
[class^="xpl-"] h5,
[class^="xpl-"] h6 {
  font-size: inherit;
  font-weight: inherit;
}
/**
 * Reset form element properties that are easy to forget to
 * style explicitly so you don't inadvertently introduce
 * styles that deviate from your design system. These styles
 * supplement a partial reset that is already applied by
 * normalize.css.
 */
[class^="xpl-"] button,
button[class^="xpl-"],
[class^="xpl-"] input,
input[class^="xpl-"],
[class^="xpl-"] optgroup,
optgroup[class^="xpl-"],
[class^="xpl-"] select,
select[class^="xpl-"],
[class^="xpl-"] textarea,
textarea[class^="xpl-"] {
  line-height: inherit;
  color: inherit;
}
/**
 * Make replaced elements `display: block` by default as that's
 * the behavior you want almost all of the time.
 *
 * https://github.com/mozdevs/cssremedy/issues/14
 */
[class^="xpl-"] img,
[class^="xpl-"] video,
[class^="xpl-"] canvas,
[class^="xpl-"] audio,
[class^="xpl-"] iframe,
[class^="xpl-"] embed,
[class^="xpl-"] object {
  display: block;
}
/**
 * Constrain images and videos to the parent width and preserve
 * their intrinsic aspect ratio.
 *
 * https://github.com/mozdevs/cssremedy/issues/14
 */
[class^="xpl-"] img,
[class^="xpl-"] video {
  max-width: 100%;
  height: auto;
}
* {
  --tw-shadow: 0 0 #0000;
  --tw-ring-inset: var(--tw-empty, /*!*/ /*!*/);
  --tw-ring-offset-width: 0;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgba(59 130 246 / 50%);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
}
.xpl-application-shell {
  grid-template:
    "nav utility utility" min-content "nav subnav content" 1fr / min-content min-content 1fr;
  max-height: 100vh;
  background-color: var(--xpl-color-navigation-lm);
}
.xpl-application-shell__nav {
    grid-area: nav;
    height: 100vh;
  }
/* Only Firefox (as of 66) support animation of Grid tracks, so we need to apply animation to the width of the bar. */
.xpl-application-shell__nav--sm,
    .xpl-application-shell__nav--md,
    .xpl-application-shell__nav--default {
      width: 0;
      transition-property: all;
      transition-timing-function: ease-in-out;
    }
.xpl-application-shell__nav--sm {
      transform: translateX(-74px);
      transition-duration: 0.2s;
    }
.xpl-application-shell__nav--sm--open {
        width: 74px;
        transition-duration: 0.2s;
      }
.xpl-application-shell__nav--md {
      transform: translateX(-112px);
      transition-duration: 0.25s;
    }
.xpl-application-shell__nav--md--open {
        width: 112px;
        transition-duration: 0.25s;
      }
.xpl-application-shell__nav--default {
      transform: translateX(-240px);
      transition-duration: 0.3s;
    }
.xpl-application-shell__nav--default--open {
        transition-duration: 0.3s;
        width: 240px;
      }
.xpl-application-shell__nav {
  position: sticky;
  top: 0px
}
.xpl-application-shell__subnav {
    grid-area: subnav;
    background-color: var(--xpl-color-foreground-lm);
    border-top: 1px solid var(--xpl-color-stroke-lm);
  }
.xpl-application-shell__utility {
    grid-area: utility;
    position: sticky;
    top: 0px;
  }
.xpl-application-shell__content {
    grid-area: content;
    background-color: var(--xpl-color-background-lm);
    border-left: 1px solid var(--xpl-color-stroke-lm);
    border-top: 1px solid var(--xpl-color-stroke-lm);
    overflow-y: auto;
  }
.xpl-application-shell {
  display: grid
}
.dark .xpl-application-shell__subnav {
  background-color: var(--xpl-color-background-2-dm);
  border-left: 1px solid var(--xpl-color-stroke-dm);
  border-top: 1px solid var(--xpl-color-stroke-dm);
}
.dark .xpl-application-shell__content {
  background-color: var(--xpl-color-background-dm);
  border-left: 1px solid var(--xpl-color-stroke-dm);
  border-top: 1px solid var(--xpl-color-stroke-dm);
}
.dark .xpl-application-shell__utility {
  border-left: 1px solid var(--xpl-color-stroke-dm);
}
@media (max-width: 1023px) {
  .xpl-application-shell {
    grid-template:
      "nav utility" min-content "nav subnav" min-content "nav content" 1fr / min-content 1fr;
    height: 100vh;
  }

    .xpl-application-shell__sidebar--open {
      grid-template-columns: min-content 100vw;
    }

    .xpl-application-shell__subnav {
      border-top: 0;
    }

    .xpl-application-shell {
    overflow: hidden
  }


  .dark .xpl-application-shell__subnav,
  .dark .xpl-application-shell__content,
  .dark .xpl-application-shell__utility {
    border-left: 0;
  }
}
@media (max-width: 640px) {
  .xpl-application-shell {
    grid-template-columns: min-content 100vw;
    height: -webkit-fill-available;
  }

    .xpl-application-shell__nav {
        max-height: -webkit-fill-available;
    }

    .xpl-application-shell__backdrop--open {
      grid-area: utility / subnav / content;
    }
}
.xpl-avatar {
  position: relative;
  display: inline-block;
  border-radius: 9999px;
  vertical-align: middle;
  text-transform: uppercase
}
a.xpl-avatar {
  text-decoration: none;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
a.xpl-avatar:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-offset-width: 2px
}
.dark a.xpl-avatar {
  --tw-ring-offset-color: #212633; /* gray-900 */
}
a.xpl-avatar:focus {
  --tw-ring-color: var(--xpl-color-secondary-lm);
}
.dark a.xpl-avatar:focus {
  --tw-ring-color: var(--xpl-color-secondary-dm);
}
a.xpl-avatar::after {
  content: '';
  position: absolute;
  top: 0px;
  left: 0px;
  display: block;
  height: 100%;
  width: 100%;
  border-radius: 9999px;
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
  opacity: 0;
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
a.xpl-avatar:hover::after,
a.xpl-avatar:active::after {
  opacity: 0.2
}
.xpl-avatar--disabled {
  cursor: not-allowed
}
.xpl-avatar img,
.xpl-avatar__placeholder {
  height: 2.5rem;
  width: 2.5rem;
  border-radius: 9999px
}
.xpl-avatar__placeholder {
  background-color: var(--xpl-color-secondary-lm);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.dark .xpl-avatar__placeholder {
  background-color: var(--xpl-color-secondary-dm);
  --tw-text-opacity: 1;
  color: rgb(48 45 59 / var(--tw-text-opacity));
}
.xpl-avatar--green .xpl-avatar__placeholder {
  --tw-bg-opacity: 1;
  background-color: rgb(116 251 208 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(48 45 59 / var(--tw-text-opacity))
}
a.xpl-avatar--green:focus,
.dark a.xpl-avatar--green:focus {
  --tw-ring-color: #74fbd0; /* green accent */
}
.xpl-avatar--yellow .xpl-avatar__placeholder {
  --tw-bg-opacity: 1;
  background-color: rgb(236 253 145 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(48 45 59 / var(--tw-text-opacity))
}
a.xpl-avatar--yellow:focus,
.dark a.xpl-avatar--yellow:focus {
  --tw-ring-color: #ecfd91; /* yellow accent */
}
.xpl-avatar--pink .xpl-avatar__placeholder {
  --tw-bg-opacity: 1;
  background-color: rgb(255 141 244 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(48 45 59 / var(--tw-text-opacity))
}
a.xpl-avatar--pink:focus,
.dark a.xpl-avatar--pink:focus {
  --tw-ring-color: #ff9ef6; /* pink accent */
}
.xpl-avatar--primary .xpl-avatar__placeholder {
  background-color: var(--xpl-color-primary-lm);
}
.xpl-avatar--sm img,
.xpl-avatar--sm .xpl-avatar__placeholder {
  height: 1.5rem;
  width: 1.5rem;
  font-size: 0.625rem;
  line-height: 0.875rem
}
.xpl-avatar--md img,
.xpl-avatar--md .xpl-avatar__placeholder {
  height: 2rem;
  width: 2rem;
  font-size: 0.625rem;
  line-height: 0.875rem
}
.dark .xpl-avatar--primary .xpl-avatar__placeholder {
  background-color: var(--xpl-color-primary-dm);
  --tw-text-opacity: 1;
  color: rgb(48 45 59 / var(--tw-text-opacity));
}
a.xpl-avatar--primary:focus {
  --tw-ring-color: var(--xpl-color-primary-lm);
}
.dark a.xpl-avatar--primary:focus {
  --tw-ring-color: var(--xpl-color-primary-dm);
}
[class^='xpl-avatar__dot'] {
  position: absolute;
  bottom: 0px;
  right: 0px;
  display: block;
  height: 0.625rem;
  width: 0.625rem;
  border-radius: 9999px;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 255 255 / var(--tw-ring-opacity));
  --tw-ring-offset-width: 0px
}
.dark [class^='xpl-avatar__dot'] {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(48 45 59 / var(--tw-ring-opacity))
}
.xpl-avatar__dot--active {
  --tw-bg-opacity: 1;
  background-color: rgb(55 184 143 / var(--tw-bg-opacity))
}
.dark .xpl-avatar__dot--active {
  --tw-bg-opacity: 1;
  background-color: rgb(82 235 186 / var(--tw-bg-opacity))
}
.xpl-avatar__dot--warning {
  --tw-bg-opacity: 1;
  background-color: rgb(242 79 61 / var(--tw-bg-opacity))
}
.dark .xpl-avatar__dot--warning {
  --tw-bg-opacity: 1;
  background-color: rgb(255 147 135 / var(--tw-bg-opacity))
}
.xpl-avatar__dot--inactive {
  --tw-bg-opacity: 1;
  background-color: rgb(225 226 232 / var(--tw-bg-opacity))
}
.xpl-avatar--md [class^='xpl-avatar__dot'] {
  height: 0.5rem;
  width: 0.5rem
}
.xpl-avatar--sm [class^='xpl-avatar__dot'] {
  height: 0.375rem;
  width: 0.375rem
}
.xpl-avatar--rounded img {
  border-radius: 0.375rem
}
.xpl-avatar-group {
  display: flex
}
.xpl-avatar-group > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(-0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(-0.5rem * calc(1 - var(--tw-space-x-reverse)))
}
.xpl-avatar-group {
  overflow: hidden
}
.xpl-avatar-group img {
  box-shadow: 0 0 0 2px #fff;
  display: inline-block;
  height: 2rem;
  width: 2rem;
  border-radius: 9999px;
}
.xpl-avatar-group--s img {
  height: 1.5rem;
  width: 1.5rem
}
.xpl-avatar-group--l img {
  height: 2.5rem;
  width: 2.5rem
}
.dark .xpl-avatar-group img {
  box-shadow: 0 0 0 2px var(--xpl-color-gray-900);
}
.xpl-avatar-group--s > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(-0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(-0.25rem * calc(1 - var(--tw-space-x-reverse)))
}
.xpl-backdrop {
  background-color: var(--xpl-color-gray-1000);
  opacity: 0.5;
}
.xpl-backdrop--fixed {
  position: fixed;
  inset: 0px
}
.xpl-backdrop--relative {
  position: relative
}
.xpl-backdrop {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms
}
.dark .xpl-backdrop {
  background-color: var(--xpl-color-gray-1200);
  opacity: 0.6;
}
.xpl-badge,
button.xpl-badge {
  padding: 4px 12px;
  display: inline-flex;
  align-items: center;
  border-radius: 9999px;
  --tw-bg-opacity: 1;
  background-color: rgb(235 229 255 / var(--tw-bg-opacity));
  font-size: 0.75rem;
  line-height: 1rem;
}
.xpl-badge--dot::before {
  content: "";
  height: 8px;
  margin: 0 4px 0 -4px;
  width: 8px;
  display: inline-block;
  border-radius: 9999px;
  --tw-bg-opacity: 1;
  background-color: rgb(136 87 250 / var(--tw-bg-opacity));
}
.dark .xpl-badge,
.dark button.xpl-badge {
  padding: 3px 11px;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(195 173 255 / var(--tw-border-opacity));
  background-color: transparent;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.dark .xpl-badge::before,
.dark button.xpl-badge::before {
  --tw-bg-opacity: 1;
  background-color: rgb(195 173 255 / var(--tw-bg-opacity))
}
.xpl-badge--success {
  --tw-bg-opacity: 1;
  background-color: rgb(196 255 237 / var(--tw-bg-opacity))
}
.xpl-badge--success::before {
  --tw-bg-opacity: 1;
  background-color: rgb(55 184 143 / var(--tw-bg-opacity))
}
.dark .xpl-badge--success {
  --tw-border-opacity: 1;
  border-color: rgb(82 235 186 / var(--tw-border-opacity))
}
.dark .xpl-badge--success::before {
  --tw-bg-opacity: 1;
  background-color: rgb(82 235 186 / var(--tw-bg-opacity))
}
.xpl-badge--warning {
  --tw-bg-opacity: 1;
  background-color: rgb(243 254 187 / var(--tw-bg-opacity))
}
.xpl-badge--warning::before {
  --tw-bg-opacity: 1;
  background-color: rgb(173 171 32 / var(--tw-bg-opacity))
}
.dark .xpl-badge--warning {
  --tw-border-opacity: 1;
  border-color: rgb(220 233 103 / var(--tw-border-opacity))
}
.dark .xpl-badge--warning::before {
  --tw-bg-opacity: 1;
  background-color: rgb(220 233 103 / var(--tw-bg-opacity))
}
.xpl-badge--inactive {
  --tw-bg-opacity: 1;
  background-color: rgb(238 239 243 / var(--tw-bg-opacity))
}
.xpl-badge--inactive::before {
  --tw-bg-opacity: 1;
  background-color: rgb(225 226 232 / var(--tw-bg-opacity))
}
.dark .xpl-badge--inactive {
  --tw-border-opacity: 1;
  border-color: rgb(225 226 232 / var(--tw-border-opacity))
}
.xpl-badge--error {
  --tw-bg-opacity: 1;
  background-color: rgb(254 217 213 / var(--tw-bg-opacity))
}
.xpl-badge--error::before {
  --tw-bg-opacity: 1;
  background-color: rgb(242 79 61 / var(--tw-bg-opacity))
}
.dark .xpl-badge--error {
  --tw-border-opacity: 1;
  border-color: rgb(255 147 135 / var(--tw-border-opacity))
}
.dark .xpl-badge--error::before {
  --tw-bg-opacity: 1;
  background-color: rgb(255 147 135 / var(--tw-bg-opacity))
}
/* stylelint-disable no-descending-specificity */
.xpl-button button,
  .xpl-button a {
    align-items: center;
    align-content: center;
    background-color: var(--xpl-color-secondary-lm);
    border-radius: var(--xpl-button-radius);
    display: inline-grid;
    gap: 6px;
    grid-auto-flow: column;
    height: 40px;
    justify-content: center;
    justify-items: center;
    padding: 10px 18px 10px 20px;
    text-decoration: none;
    white-space: nowrap;
  }
.xpl-button button svg, .xpl-button a svg {
      width: 15px;
      height: 15px;
    }
.xpl-button button:hover, .xpl-button a:hover {
      background-color: var(--xpl-color-secondary-hover-lm);
      --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
      --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
      box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
    }
.xpl-button button:active, .xpl-button a:active {
      --tw-ring-color: var(--xpl-color-purple-500);

      background-color: var(--xpl-color-secondary-hover-lm);

      --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);

      --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);

      box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);

      --tw-ring-offset-width: 2px;
    }
.xpl-button button:focus, .xpl-button a:focus {
      --tw-ring-color: var(--xpl-color-purple-500);

      border-color: var(--xpl-color-secondary-lm);

      --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);

      --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);

      box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);

      --tw-ring-offset-width: 2px;
    }
.xpl-button button:disabled,
    .xpl-button button:disabled:hover,
    .xpl-button a:disabled,
    .xpl-button a:disabled:hover {
      background-color: var(--xpl-color-action-disabled-lm);
      border-color: var(--xpl-color-action-disabled-lm);
      color: var(--xpl-color-text-secondary-lm);
      cursor: not-allowed;
      --tw-shadow: 0 0 #0000;
      --tw-shadow-colored: 0 0 #0000;
      box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
    }
.xpl-button button,
  .xpl-button a {
  cursor: pointer;
  border-radius: 9999px;
  border-width: 1px;
  border-color: transparent;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms
}
.xpl-button button:focus,
  .xpl-button a:focus {
  outline: 2px solid transparent;
  outline-offset: 2px
}
.xpl-button--sm button,
    .xpl-button--sm a,
    .xpl-button--xs button,
    .xpl-button--xs a {
      font-size: 0.75rem;
    }
.xpl-button--sm button svg, .xpl-button--sm a svg, .xpl-button--xs button svg, .xpl-button--xs a svg {
        width: 12px;
      }
.xpl-button--sm button,
    .xpl-button--sm a {
      height: 32px;
      padding: 8px 16px;
    }
.xpl-button--xs button,
    .xpl-button--xs a {
      height: 24px;
      padding: 4px 10px;
    }
.xpl-button--icon-only button,
    .xpl-button--icon-only a {
      display: flex;
      justify-content: center;
      padding: 0;
      width: 40px;
    }
.xpl-button--icon-only button svg, .xpl-button--icon-only a svg {
        height: 18px;
        width: 18px;
      }
.xpl-button--icon-only.xpl-button--sm a,
      .xpl-button--icon-only.xpl-button--sm button {
        height: 32px;
        width: 32px;
      }
.xpl-button--icon-only.xpl-button--sm a svg, .xpl-button--icon-only.xpl-button--sm button svg {
          height: 15px;
          width: 15px;
        }
.xpl-button--icon-only.xpl-button--xs a,
      .xpl-button--icon-only.xpl-button--xs button {
        height: 24px;
        width: 24px;
      }
.xpl-button--icon-only.xpl-button--xs a svg, .xpl-button--icon-only.xpl-button--xs button svg {
          height: 12px;
          width: 12px;
        }
.xpl-button--secondary a:hover, .xpl-button--secondary button:hover {
        border-color: var(--xpl-color-secondary-lm);
        --tw-bg-opacity: 1;
        background-color: rgb(255 255 255 / var(--tw-bg-opacity));
      }
.xpl-button--secondary a:active, .xpl-button--secondary button:active {
        --tw-ring-color: var(--xpl-color-purple-500);

        border-color: var(--xpl-color-action-primary-lm);

        --tw-bg-opacity: 1;

        background-color: rgb(255 255 255 / var(--tw-bg-opacity));
      }
.xpl-button--secondary a:focus, .xpl-button--secondary button:focus {
        --tw-ring-color: var(--xpl-color-purple-500);
        --tw-border-opacity: 1;
        border-color: rgb(234 235 239 / var(--tw-border-opacity));
      }
.xpl-button--secondary a,
    .xpl-button--secondary button {
  --tw-border-opacity: 1;
  border-color: rgb(234 235 239 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(48 45 59 / var(--tw-text-opacity))
}
.xpl-button--subtle a:hover, .xpl-button--subtle button:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity))
}
.xpl-button--subtle a:active, .xpl-button--subtle button:active {
        --tw-ring-color: var(--xpl-color-gray-400);
        --tw-bg-opacity: 1;
        background-color: rgb(234 235 239 / var(--tw-bg-opacity));
      }
.xpl-button--subtle a:focus, .xpl-button--subtle button:focus {
        --tw-ring-color: var(--xpl-color-gray-400);

        border-color: transparent;

        --tw-bg-opacity: 1;

        background-color: rgb(248 249 250 / var(--tw-bg-opacity));
      }
.xpl-button--subtle a,
    .xpl-button--subtle button {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(48 45 59 / var(--tw-text-opacity))
}
.xpl-button--success a:hover, .xpl-button--success button:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(29 97 75 / var(--tw-bg-opacity))
}
.xpl-button--success a:active, .xpl-button--success button:active {
        --tw-ring-color: var(--xpl-color-green-600);
        --tw-bg-opacity: 1;
        background-color: rgb(29 97 75 / var(--tw-bg-opacity));
      }
.xpl-button--success a:focus, .xpl-button--success button:focus {
        --tw-ring-color: var(--xpl-color-green-600);

        border-color: transparent;

        --tw-bg-opacity: 1;

        background-color: rgb(36 120 93 / var(--tw-bg-opacity));
      }
.xpl-button--success a,
    .xpl-button--success button {
  --tw-bg-opacity: 1;
  background-color: rgb(36 120 93 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity))
}
.xpl-button--success.xpl-button--secondary a,
      .xpl-button--success.xpl-button--secondary button {
        background-color: transparent;
        color: var(--xpl-color-green-600);
      }
.xpl-button--success.xpl-button--secondary a:hover, .xpl-button--success.xpl-button--secondary button:hover {
          background-color: transparent;
          border-color: var(--xpl-color-green-600);
        }
.xpl-button--success.xpl-button--secondary a:active, .xpl-button--success.xpl-button--secondary button:active {
          background-color: transparent;
          border-color: var(--xpl-color-green-600);
        }
.xpl-button--success.xpl-button--secondary a:focus, .xpl-button--success.xpl-button--secondary button:focus {
          background-color: transparent;
          --tw-border-opacity: 1;
          border-color: rgb(234 235 239 / var(--tw-border-opacity));
        }
.xpl-button--success.xpl-button--secondary a:disabled,
        .xpl-button--success.xpl-button--secondary a:disabled:hover,
        .xpl-button--success.xpl-button--secondary button:disabled,
        .xpl-button--success.xpl-button--secondary button:disabled:hover {
          background-color: var(--xpl-color-action-disabled-lm);
          border-color: var(--xpl-color-action-disabled-lm);
          color: var(--xpl-color-text-secondary-lm);
        }
.xpl-button--success.xpl-button--subtle a:hover, .xpl-button--success.xpl-button--subtle button:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity))
}
.xpl-button--success.xpl-button--subtle a:active, .xpl-button--success.xpl-button--subtle button:active {
          --tw-ring-color: var(--xpl-color-gray-400);
          --tw-bg-opacity: 1;
          background-color: rgb(234 235 239 / var(--tw-bg-opacity));
        }
.xpl-button--success.xpl-button--subtle a:focus, .xpl-button--success.xpl-button--subtle button:focus {
          --tw-ring-color: var(--xpl-color-gray-400);

          border-color: transparent;

          --tw-bg-opacity: 1;

          background-color: rgb(248 249 250 / var(--tw-bg-opacity));
        }
.xpl-button--success.xpl-button--subtle a:disabled,
        .xpl-button--success.xpl-button--subtle a:disabled:hover,
        .xpl-button--success.xpl-button--subtle button:disabled,
        .xpl-button--success.xpl-button--subtle button:disabled:hover {
          background-color: var(--xpl-color-action-disabled-lm);
          border-color: var(--xpl-color-action-disabled-lm);
          color: var(--xpl-color-text-secondary-lm);
        }
.xpl-button--success.xpl-button--subtle a,
      .xpl-button--success.xpl-button--subtle button {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(36 120 93 / var(--tw-text-opacity))
}
.xpl-button--warning a,
    .xpl-button--warning button {
      background-color: var(--xpl-color-action-warning-lm);
    }
.xpl-button--warning a:hover, .xpl-button--warning button:hover {
        background-color: var(--xpl-color-action-warning-hover-lm);
      }
.xpl-button--warning a:active, .xpl-button--warning button:active {
        --tw-ring-color: var(--xpl-color-red-700);

        background-color: var(--xpl-color-action-warning-hover-lm);
      }
.xpl-button--warning a:focus, .xpl-button--warning button:focus {
        --tw-ring-color: var(--xpl-color-action-warning-lm);

        background-color: var(--xpl-color-action-warning-lm);
        border-color: transparent;
      }
.xpl-button--warning a,
    .xpl-button--warning button {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity))
}
.xpl-button--warning.xpl-button--secondary a,
      .xpl-button--warning.xpl-button--secondary button {
        background-color: transparent;
        color: var(--xpl-color-text-warning-lm);
      }
.xpl-button--warning.xpl-button--secondary a:hover, .xpl-button--warning.xpl-button--secondary button:hover {
          background-color: transparent;
          border-color: var(--xpl-color-text-warning-lm);
        }
.xpl-button--warning.xpl-button--secondary a:active, .xpl-button--warning.xpl-button--secondary button:active {
          background-color: transparent;
          border-color: var(--xpl-color-text-warning-lm);
        }
.xpl-button--warning.xpl-button--secondary a:focus, .xpl-button--warning.xpl-button--secondary button:focus {
          background-color: transparent;
          --tw-border-opacity: 1;
          border-color: rgb(234 235 239 / var(--tw-border-opacity));
        }
.xpl-button--warning.xpl-button--secondary a:disabled,
        .xpl-button--warning.xpl-button--secondary a:disabled:hover,
        .xpl-button--warning.xpl-button--secondary button:disabled,
        .xpl-button--warning.xpl-button--secondary button:disabled:hover {
          background-color: var(--xpl-color-action-disabled-lm);
          border-color: var(--xpl-color-action-disabled-lm);
          color: var(--xpl-color-text-secondary-lm);
        }
.xpl-button--warning.xpl-button--subtle a,
      .xpl-button--warning.xpl-button--subtle button {
        color: var(--xpl-color-text-warning-lm);
      }
.xpl-button--warning.xpl-button--subtle a:hover, .xpl-button--warning.xpl-button--subtle button:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity))
}
.xpl-button--warning.xpl-button--subtle a:active, .xpl-button--warning.xpl-button--subtle button:active {
          --tw-ring-color: var(--xpl-color-gray-400);
          --tw-bg-opacity: 1;
          background-color: rgb(234 235 239 / var(--tw-bg-opacity));
        }
.xpl-button--warning.xpl-button--subtle a:focus, .xpl-button--warning.xpl-button--subtle button:focus {
          --tw-ring-color: var(--xpl-color-gray-400);

          border-color: transparent;

          --tw-bg-opacity: 1;

          background-color: rgb(248 249 250 / var(--tw-bg-opacity));
        }
.xpl-button--warning.xpl-button--subtle a:disabled,
        .xpl-button--warning.xpl-button--subtle a:disabled:hover,
        .xpl-button--warning.xpl-button--subtle button:disabled,
        .xpl-button--warning.xpl-button--subtle button:disabled:hover {
          background-color: var(--xpl-color-action-disabled-lm);
          border-color: var(--xpl-color-action-disabled-lm);
          color: var(--xpl-color-text-secondary-lm);
        }
.xpl-button--warning.xpl-button--subtle a,
      .xpl-button--warning.xpl-button--subtle button {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity))
}
.dark .xpl-button a,
  .dark .xpl-button button {
    background-color: var(--xpl-color-secondary-dm);
    color: var(--xpl-color-text-reverse-dm);
  }
.dark .xpl-button a:hover, .dark .xpl-button button:hover {
      background-color: var(--xpl-color-secondary-hover-dm);
      border-color: transparent;
    }
.dark .xpl-button a:focus, .dark .xpl-button button:focus {
      --tw-ring-color: var(--xpl-color-purple-500);
      --tw-ring-offset-color: var(--xpl-color-foreground-dm);

      border-color: transparent;
    }
.dark .xpl-button a:active, .dark .xpl-button button:active {
      --tw-ring-color: var(--xpl-color-purple-500);
      --tw-ring-offset-color: var(--xpl-color-foreground-dm);

      background-color: var(--xpl-color-secondary-hover-dm);
    }
.dark .xpl-button--secondary a,
    .dark .xpl-button--secondary button {
      border-color: var(--xpl-color-gray-600);
      background-color: var(--xpl-color-foreground-dm);
    }
.dark .xpl-button--secondary a:hover,
      .dark .xpl-button--secondary a:active,
      .dark .xpl-button--secondary a:focus,
      .dark .xpl-button--secondary button:hover,
      .dark .xpl-button--secondary button:active,
      .dark .xpl-button--secondary button:focus {
        background-color: var(--xpl-color-foreground-dm);
      }
.dark .xpl-button--secondary a:hover, .dark .xpl-button--secondary button:hover {
        border-color: var(--xpl-color-secondary-dm);
      }
.dark .xpl-button--secondary a:active, .dark .xpl-button--secondary button:active {
        border-color: var(--xpl-color-secondary-dm);
      }
.dark .xpl-button--secondary a:focus, .dark .xpl-button--secondary button:focus {
        --tw-ring-color: var(--xpl-color-secondary-dm);

        border-color: var(--xpl-color-gray-600);
      }
.dark .xpl-button--secondary a,
    .dark .xpl-button--secondary button {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity))
}
.dark .xpl-button--subtle a:hover, .dark .xpl-button--subtle button:hover {
        border-color: transparent;
        --tw-bg-opacity: 1;
        background-color: rgb(54 50 64 / var(--tw-bg-opacity));
      }
.dark .xpl-button--subtle a:active, .dark .xpl-button--subtle button:active {
        --tw-ring-color: var(--xpl-color-gray-700);
        --tw-bg-opacity: 1;
        background-color: rgb(60 56 71 / var(--tw-bg-opacity));
      }
.dark .xpl-button--subtle a:focus, .dark .xpl-button--subtle button:focus {
        --tw-ring-color: var(--xpl-color-gray-700);

        background-color: var(--xpl-color-foreground-dm);
        border-color: transparent;
      }
.dark .xpl-button--subtle a,
    .dark .xpl-button--subtle button {
  background-color: transparent;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity))
}
.dark .xpl-button--success a,
    .dark .xpl-button--success button {
      color: var(--xpl-color-reverse-dm);
    }
.dark .xpl-button--success a:hover, .dark .xpl-button--success button:hover {
        border-color: transparent;
        --tw-bg-opacity: 1;
        background-color: rgb(74 212 168 / var(--tw-bg-opacity));
      }
.dark .xpl-button--success a:active, .dark .xpl-button--success button:active {
        --tw-ring-color: var(--xpl-color-green-200);
        --tw-bg-opacity: 1;
        background-color: rgb(74 212 168 / var(--tw-bg-opacity));
      }
.dark .xpl-button--success a:focus, .dark .xpl-button--success button:focus {
        --tw-ring-color: var(--xpl-color-green-200);

        border-color: transparent;

        --tw-bg-opacity: 1;

        background-color: rgb(116 251 208 / var(--tw-bg-opacity));
      }
.dark .xpl-button--success a,
    .dark .xpl-button--success button {
  --tw-bg-opacity: 1;
  background-color: rgb(116 251 208 / var(--tw-bg-opacity))
}
.dark .xpl-button--success.xpl-button--secondary a,
      .dark .xpl-button--success.xpl-button--secondary button {
        background-color: var(--xpl-color-foreground-dm);
        color: var(--xpl-color-green-200);
      }
.dark .xpl-button--success.xpl-button--secondary a:hover,
        .dark .xpl-button--success.xpl-button--secondary a:active,
        .dark .xpl-button--success.xpl-button--secondary a:focus,
        .dark .xpl-button--success.xpl-button--secondary button:hover,
        .dark .xpl-button--success.xpl-button--secondary button:active,
        .dark .xpl-button--success.xpl-button--secondary button:focus {
          background-color: var(--xpl-color-foreground-dm);
        }
.dark .xpl-button--success.xpl-button--secondary a:hover, .dark .xpl-button--success.xpl-button--secondary button:hover {
          border-color: var(--xpl-color-green-200);
        }
.dark .xpl-button--success.xpl-button--secondary a:active, .dark .xpl-button--success.xpl-button--secondary button:active {
          border-color: var(--xpl-color-green-200);
        }
.dark .xpl-button--success.xpl-button--secondary a:focus, .dark .xpl-button--success.xpl-button--secondary button:focus {
          border-color: var(--xpl-color-stroke-dm);
        }
.dark .xpl-button--success.xpl-button--subtle a:hover, .dark .xpl-button--success.xpl-button--subtle button:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(54 50 64 / var(--tw-bg-opacity))
}
.dark .xpl-button--success.xpl-button--subtle a:active, .dark .xpl-button--success.xpl-button--subtle button:active {
          --tw-ring-color: var(--xpl-color-gray-700);
          --tw-bg-opacity: 1;
          background-color: rgb(60 56 71 / var(--tw-bg-opacity));
        }
.dark .xpl-button--success.xpl-button--subtle a:focus, .dark .xpl-button--success.xpl-button--subtle button:focus {
          --tw-ring-color: var(--xpl-color-gray-700);

          background-color: var(--xpl-color-foreground-dm);
          border-color: transparent;
        }
.dark .xpl-button--success.xpl-button--subtle a,
      .dark .xpl-button--success.xpl-button--subtle button {
  background-color: transparent;
  --tw-text-opacity: 1;
  color: rgb(116 251 208 / var(--tw-text-opacity))
}
.dark .xpl-button--warning a,
    .dark .xpl-button--warning button {
      background-color: var(--xpl-color-action-warning-dm);
      color: var(--xpl-color-reverse-dm);
    }
.dark .xpl-button--warning a:hover, .dark .xpl-button--warning button:hover {
        border-color: transparent;
        background-color: var(--xpl-color-action-warning-hover-dm);
      }
.dark .xpl-button--warning a:active, .dark .xpl-button--warning button:active {
        --tw-ring-color: var(--xpl-color-red-300);

        background-color: var(--xpl-color-action-warning-hover-dm);
      }
.dark .xpl-button--warning a:focus, .dark .xpl-button--warning button:focus {
        --tw-ring-color: var(--xpl-color-red-300);

        background-color: var(--xpl-color-action-warning-dm);
        border-color: transparent;
      }
.dark .xpl-button--warning.xpl-button--secondary a,
      .dark .xpl-button--warning.xpl-button--secondary button {
        background-color: var(--xpl-color-foreground-dm);
        color: var(--xpl-color-text-warning-dm);
      }
.dark .xpl-button--warning.xpl-button--secondary a:hover,
        .dark .xpl-button--warning.xpl-button--secondary a:active,
        .dark .xpl-button--warning.xpl-button--secondary a:focus,
        .dark .xpl-button--warning.xpl-button--secondary button:hover,
        .dark .xpl-button--warning.xpl-button--secondary button:active,
        .dark .xpl-button--warning.xpl-button--secondary button:focus {
          background-color: var(--xpl-color-foreground-dm);
        }
.dark .xpl-button--warning.xpl-button--secondary a:hover, .dark .xpl-button--warning.xpl-button--secondary button:hover {
          border-color: var(--xpl-color-text-warning-dm);
        }
.dark .xpl-button--warning.xpl-button--secondary a:active, .dark .xpl-button--warning.xpl-button--secondary button:active {
          border-color: var(--xpl-color-text-warning-dm);
        }
.dark .xpl-button--warning.xpl-button--secondary a:focus, .dark .xpl-button--warning.xpl-button--secondary button:focus {
          border-color: var(--xpl-color-stroke-dm);
        }
.dark .xpl-button--warning.xpl-button--subtle a,
      .dark .xpl-button--warning.xpl-button--subtle button {
        color: var(--xpl-color-text-warning-dm);
      }
.dark .xpl-button--warning.xpl-button--subtle a:hover, .dark .xpl-button--warning.xpl-button--subtle button:hover {
          border-color: transparent;
          --tw-bg-opacity: 1;
          background-color: rgb(54 50 64 / var(--tw-bg-opacity));
        }
.dark .xpl-button--warning.xpl-button--subtle a:active, .dark .xpl-button--warning.xpl-button--subtle button:active {
          --tw-ring-color: var(--xpl-color-gray-700);
          --tw-bg-opacity: 1;
          background-color: rgb(60 56 71 / var(--tw-bg-opacity));
        }
.dark .xpl-button--warning.xpl-button--subtle a:focus, .dark .xpl-button--warning.xpl-button--subtle button:focus {
          --tw-ring-color: var(--xpl-color-gray-700);

          background-color: var(--xpl-color-foreground-dm);
          border-color: transparent;
        }
.dark .xpl-button--warning.xpl-button--subtle a,
      .dark .xpl-button--warning.xpl-button--subtle button {
  background-color: transparent
}
/* stylelint-disable-next-line no-duplicate-selectors */
.dark .xpl-button a:disabled,
    .dark .xpl-button a:disabled:hover,
    .dark .xpl-button button:disabled,
    .dark .xpl-button button:disabled:hover {
      background-color: var(--xpl-color-action-disabled-dm);
      border-color: transparent;
      color: var(--xpl-color-text-secondary-dm);
      --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
      --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
      box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
    }
.xpl-button--link-disabled a,
  .xpl-button--link-disabled a:hover,
  .xpl-button--link-disabled a:focus,
  .xpl-button--link-disabled a:active,
  .xpl-button--link-disabled.xpl-button--success a,
  .xpl-button--link-disabled.xpl-button--success a:hover,
  .xpl-button--link-disabled.xpl-button--success a:focus,
  .xpl-button--link-disabled.xpl-button--success a:active,
  .xpl-button--link-disabled.xpl-button--warning a,
  .xpl-button--link-disabled.xpl-button--warning a:hover,
  .xpl-button--link-disabled.xpl-button--warning a:focus,
  .xpl-button--link-disabled.xpl-button--warning a:active,
  .xpl-button--link-disabled.xpl-button--neutral a,
  .xpl-button--link-disabled.xpl-button--neutral a:hover,
  .xpl-button--link-disabled.xpl-button--neutral a:focus,
  .xpl-button--link-disabled.xpl-button--neutral a:active {
    background-color: var(--xpl-color-action-disabled-lm);
    border-color: var(--xpl-color-action-disabled-lm);
    color: var(--xpl-color-text-secondary-lm);
    cursor: not-allowed;
    border-width: 0px;
    --tw-shadow: 0 0 #0000;
    --tw-shadow-colored: 0 0 #0000;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  }
.dark .xpl-button--link-disabled a,
    .dark .xpl-button--link-disabled a:hover,
    .dark .xpl-button--link-disabled a:focus,
    .dark .xpl-button--link-disabled a:active,
    .dark .xpl-button--link-disabled.xpl-button--success a,
    .dark .xpl-button--link-disabled.xpl-button--success a:hover,
    .dark .xpl-button--link-disabled.xpl-button--success a:focus,
    .dark .xpl-button--link-disabled.xpl-button--success a:active,
    .dark .xpl-button--link-disabled.xpl-button--warning a,
    .dark .xpl-button--link-disabled.xpl-button--warning a:hover,
    .dark .xpl-button--link-disabled.xpl-button--warning a:focus,
    .dark .xpl-button--link-disabled.xpl-button--warning a:active,
    .dark .xpl-button--link-disabled.xpl-button--neutral a,
    .dark .xpl-button--link-disabled.xpl-button--neutral a:hover,
    .dark .xpl-button--link-disabled.xpl-button--neutral a:focus,
    .dark .xpl-button--link-disabled.xpl-button--neutral a:active {
      background-color: var(--xpl-color-action-disabled-dm);
      border-color: transparent;
      color: var(--xpl-color-text-secondary-dm);
      cursor: not-allowed;
      --tw-shadow: 0 0 #0000;
      --tw-shadow-colored: 0 0 #0000;
      box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
      --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
      --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
      box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
    }
.xpl-button--full-width a,
  .xpl-button--full-width button {
    width: 100%;
  }
.xpl-button-row {
  display: block;
  width: 100%;
  border-top-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(225 226 232 / var(--tw-border-opacity));
  padding-top: 1.25rem
}
.dark .xpl-button-row {
  --tw-border-opacity: 1;
  border-color: rgb(106 109 125 / var(--tw-border-opacity))
}
.xpl-button-row-inner {
  display: flex;
  justify-content: space-between
}
.xpl-button-row xpl-button + xpl-button .xpl-button {
  margin-left: 1rem
}
.xpl-button-row__right .xpl-button--secondary {
  display: none;
}
.xpl-button-row__right {
  display: flex
}
@media screen and (max-width: 640px) {
  .xpl-button-row-inner {
    display: block
  }
    .xpl-button-row .xpl-button a,
    .xpl-button-row .xpl-button button {
    margin-bottom: 1rem;
    width: 100%;
    justify-content: center
  }

  .xpl-button-row xpl-button + xpl-button .xpl-button {
    margin-left: 0px
  }

  .xpl-button-row__left .xpl-button--secondary {
    display: none;
  }

  .xpl-button-row__right .xpl-button--secondary {
    display: block;
  }

  /* so that tertiary appears below primary */
  .xpl-button-row__right {
    flex-direction: column-reverse
  }

  /* target the first because we're reversing it */
  .xpl-button-row__right xpl-button:first-child .xpl-button {
    margin-bottom: 0px
  }
}
.xpl-breadcrumbs a {
    color: inherit;
    text-decoration: none;
  }
.xpl-breadcrumbs ol {
    color: var(--xpl-color-text-secondary-lm);
  }
.xpl-breadcrumbs ol span {
      color: var(--xpl-color-text-secondary-dm);
    }
.xpl-breadcrumbs ol span svg {
        height: 9px;
        margin-top: 0.125rem;
      }
.xpl-breadcrumbs ol span {
  display: grid;
  align-content: center
}
.xpl-breadcrumbs ol .xpl-breadcrumb-item:hover {
        color: var(--xpl-color-action-primary-lm);
      }
.xpl-breadcrumbs ol .xpl-breadcrumb-item a,
      .xpl-breadcrumbs ol .xpl-breadcrumb-item button,
      .xpl-breadcrumbs ol .xpl-breadcrumb-item span {
  padding-right: 0.5rem
}
.xpl-breadcrumbs ol .xpl-breadcrumb-item:nth-last-of-type(3) {
  display: none
}
.flatpickr-day.xpl-breadcrumbs ol .xpl-breadcrumb-item:nth-last-of-type(3){visibility:hidden}
@media (min-width: 768px) {
  .xpl-breadcrumbs ol .xpl-breadcrumb-item:nth-last-of-type(3) {
    display: flex
  }
}
.xpl-breadcrumbs ol .xpl-breadcrumb-item:last-child {
        color: var(--xpl-color-text-primary-lm);
      }
.xpl-breadcrumbs ol .xpl-breadcrumb-item:last-child:hover {
          color: var(--xpl-color-action-primary-lm);
        }
.xpl-breadcrumbs ol .xpl-breadcrumb-item:last-child span {
  display: none
}
.flatpickr-day.xpl-breadcrumbs ol .xpl-breadcrumb-item:last-child span{visibility:hidden}
.xpl-breadcrumbs ol .xpl-breadcrumb-item:last-child {
  pointer-events: none;
  cursor: default;
  text-decoration-line: none
}
.xpl-breadcrumbs ol .xpl-breadcrumb-item {
  display: flex;
  align-content: center
}
.xpl-breadcrumbs ol {
  display: flex;
  align-content: center;
  font-size: 0.875rem;
  line-height: 1.25rem
}
/* stylelint-disable no-descending-specificity, because the rule was expecting some of the code below to appear before some code that is nested above. */
.dark .xpl-breadcrumbs ol {
    color: var(--xpl-color-text-secondary-dm);
  }
.dark .xpl-breadcrumbs ol .xpl-breadcrumb-item:hover {
        color: var(--xpl-color-action-primary-dm);
      }
.dark .xpl-breadcrumbs ol .xpl-breadcrumb-item:last-child {
        color: var(--xpl-color-text-primary-dm);
      }
.dark .xpl-breadcrumbs ol .xpl-breadcrumb-item:last-child:hover {
          color: var(--xpl-color-action-primary-dm);
        }
.dark .xpl-breadcrumbs ol span {
      color: var(--xpl-color-text-secondary-lm);
    }
/**
 * Since the UIs for checkboxes and radios are so
 * similar, both components find their styles here.
 */
.xpl-checkbox-radio-container {
  margin-bottom: 1.5rem;
  display: flex
}
.xpl-checkbox-radio-container.styled {
  position: relative;
  overflow: hidden;
  border-radius: 0.375rem;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(225 226 232 / var(--tw-border-opacity));
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms
}
.dark .xpl-checkbox-radio-container.styled {
  --tw-border-opacity: 1;
  border-color: rgb(106 109 125 / var(--tw-border-opacity))
}
.xpl-checkbox-radio-container.styled.disabled {
  /* override hover */
  --tw-border-opacity: 1 !important;
  border-color: rgb(225 226 232 / var(--tw-border-opacity)) !important;
}
.dark .xpl-checkbox-radio-container.styled.disabled {
  /* override hover */
  --tw-border-opacity: 1 !important;
  border-color: rgb(106 109 125 / var(--tw-border-opacity)) !important;
}
.xpl-checkbox-radio-container.styled:hover,
.xpl-checkbox-radio-container.styled:focus-within {
  border-color: var(--xpl-color-secondary-lm);
}
.dark .xpl-checkbox-radio-container.styled:hover,
.dark .xpl-checkbox-radio-container.styled:focus-within {
  border-color: var(--xpl-color-secondary-dm);
}
.xpl-checkbox {
  border-radius: 4px;
  height: 16px;
  top: 2px;
  width: 16px;
  position: relative;
  cursor: pointer;
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(153 155 168 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.xpl-checkbox:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-offset-width: 2px
}
.dark .xpl-checkbox {
  --tw-ring-offset-color: var(--xpl-color-gray-1200);
  --tw-border-opacity: 1;
  border-color: rgb(153 155 168 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(24 22 31 / var(--tw-bg-opacity));
}
.xpl-checkbox:hover,
.xpl-checkbox:checked,
.xpl-checkbox:indeterminate {
  border-color: var(--xpl-color-secondary-lm);
}
.xpl-checkbox:checked,
.xpl-checkbox:indeterminate {
  background-color: var(--xpl-color-secondary-lm);
}
.xpl-checkbox:disabled {
  cursor: not-allowed;
  --tw-border-opacity: 1;
  border-color: rgb(225 226 232 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(225 226 232 / var(--tw-bg-opacity))
}
.xpl-checkbox:focus {
  --tw-ring-color: var(--xpl-color-secondary-lm);
}
.xpl-checkbox-radio-container.styled input {
  --tw-ring-color: transparent;
  --tw-ring-offset-color: transparent;
  position: absolute;
  margin-left: 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.xpl-checkbox-radio-container input + label {
  cursor: pointer;
  padding-left: 1rem;
  padding-right: 1rem;
  vertical-align: middle
}
.xpl-checkbox-radio-container.styled label {
  display: block;
  width: 100%;
  padding-left: 3rem;
  padding-top: 1rem;
  padding-right: 1rem;
  padding-bottom: 1rem;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms
}
.xpl-checkbox-radio-container.styled input:disabled + label {
  --tw-bg-opacity: 1;
  background-color: rgb(248 249 250 / var(--tw-bg-opacity))
}
.xpl-checkbox-radio-container.styled input:checked + label,
.xpl-checkbox-radio-container.styled .xpl-checkbox:indeterminate + label {
  --tw-bg-opacity: 1;
  background-color: rgb(244 242 255 / var(--tw-bg-opacity))
}
.dark .xpl-checkbox-radio-container.styled input:disabled + label {
  --tw-bg-opacity: 1;
  background-color: rgb(54 50 64 / var(--tw-bg-opacity))
}
.dark .xpl-checkbox-radio-container.styled input:checked + label,
.dark .xpl-checkbox-radio-container.styled .xpl-checkbox:indeterminate + label {
  --tw-bg-opacity: 1;
  background-color: rgb(48 45 59 / var(--tw-bg-opacity))
}
.xpl-checkbox-radio-container.styled .xpl-checkbox:disabled:indeterminate + label {
  --tw-bg-opacity: 1;
  background-color: rgb(248 249 250 / var(--tw-bg-opacity))
}
.xpl-checkbox::after {
  content: "";
  height: 16px;
  width: 16px;
  display: block;
  background-repeat: no-repeat;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
  opacity: 0;
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.dark .xpl-checkbox:focus {
  --tw-ring-color: var(--xpl-color-secondary-dm);
}
.dark .xpl-checkbox:hover,
.dark .xpl-checkbox:checked,
.dark .xpl-checkbox:indeterminate {
  border-color: var(--xpl-color-secondary-dm);
}
.dark .xpl-checkbox:checked,
.dark .xpl-checkbox:indeterminate {
  background-color: var(--xpl-color-secondary-dm);
}
.dark .xpl-checkbox:disabled {
  --tw-border-opacity: 1;
  border-color: rgb(106 109 125 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(106 109 125 / var(--tw-bg-opacity))
}
.xpl-checkbox:disabled:checked,
.xpl-checkbox:disabled:indeterminate,
.dark .xpl-checkbox:disabled:checked,
.dark .xpl-checkbox:disabled:indeterminate {
  --tw-border-opacity: 1;
  border-color: rgb(153 155 168 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(153 155 168 / var(--tw-bg-opacity))
}
.xpl-checkbox-radio-container.styled .xpl-checkbox:focus {
  --tw-ring-color: transparent;
  --tw-border-opacity: 1;
  border-color: rgb(153 155 168 / var(--tw-border-opacity));
}
.xpl-checkbox-radio-container.styled .xpl-checkbox:checked:focus {
  border-color: var(--xpl-color-secondary-lm);
}
.xpl-checkbox:indeterminate::after {
  background-position: calc(50% - 1px) calc(50% - 1px);
  background-image: url("data:image/svg+xml,%3Csvg width='10' height='7' viewBox='0 0 10 7' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 2.5L10 2.5L10 4.5L0 4.5Z' fill='white'/%3E%3C/svg%3E%0A");
  opacity: 1;
}
.xpl-checkbox:checked::after {
  background-image: url("data:image/svg+xml,%3Csvg width='11' height='8' viewBox='0 0 11 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4.37866 7.6145C4.57397 7.80981 4.90601 7.80981 5.10132 7.6145L10.8435 1.87231C11.0388 1.677 11.0388 1.34497 10.8435 1.14966L10.1404 0.446533C9.94507 0.251221 9.63257 0.251221 9.43726 0.446533L4.74976 5.13403L2.54272 2.94653C2.34741 2.75122 2.03491 2.75122 1.8396 2.94653L1.13647 3.64966C0.941162 3.84497 0.941162 4.177 1.13647 4.37231L4.37866 7.6145Z' fill='white'/%3E%3C/svg%3E%0A");
  background-position: calc(50% - 1px) calc(50% - 1px);
  opacity: 1;
}
.dark .xpl-checkbox::after {
  background-image: url("data:image/svg+xml,%3Csvg width='11' height='8' viewBox='0 0 11 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4.37866 7.6145C4.57397 7.80981 4.90601 7.80981 5.10132 7.6145L10.8435 1.87231C11.0388 1.677 11.0388 1.34497 10.8435 1.14966L10.1404 0.446533C9.94507 0.251221 9.63257 0.251221 9.43726 0.446533L4.74976 5.13403L2.54272 2.94653C2.34741 2.75122 2.03491 2.75122 1.8396 2.94653L1.13647 3.64966C0.941162 3.84497 0.941162 4.177 1.13647 4.37231L4.37866 7.6145Z' fill='%23292632'/%3E%3C/svg%3E%0A");
}
.dark .xpl-checkbox:indeterminate::after {
  background-image: url("data:image/svg+xml,%3Csvg width='10' height='7' viewBox='0 0 10 7' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 2.5L10 2.5L10 4.5L0 4.5Z' fill='%23292632'/%3E%3C/svg%3E%0A");
}
.xpl-radio {
  height: 16px;
  top: 2px;
  transition-property: border;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
  width: 16px;
  position: relative;
  cursor: pointer;
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  border-radius: 9999px;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(153 155 168 / var(--tw-border-opacity));
}
.xpl-radio:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-offset-width: 2px
}
.dark .xpl-radio {
  --tw-ring-offset-color: var(--xpl-color-gray-1200);
}
.xpl-radio:checked {
  border-width: 5px;
}
.xpl-radio:hover,
.xpl-radio:active,
.xpl-radio:checked {
  border-color: var(--xpl-color-secondary-lm);
}
.xpl-radio:focus {
  --tw-ring-color: var(--xpl-color-secondary-lm);
}
.xpl-radio:disabled {
  cursor: not-allowed;
  --tw-border-opacity: 1;
  border-color: rgb(225 226 232 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(225 226 232 / var(--tw-bg-opacity))
}
.xpl-radio:disabled:checked {
  --tw-border-opacity: 1;
  border-color: rgb(153 155 168 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity))
}
.dark .xpl-radio:hover,
.dark .xpl-radio:active,
.dark .xpl-radio:checked {
  border-color: var(--xpl-color-secondary-dm);
}
.dark .xpl-radio:disabled {
  --tw-border-opacity: 1;
  border-color: rgb(106 109 125 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(106 109 125 / var(--tw-bg-opacity))
}
.dark .xpl-radio:focus {
  --tw-ring-color: var(--xpl-color-secondary-dm);
}
.dark .xpl-radio:disabled:checked {
  --tw-border-opacity: 1;
  border-color: rgb(153 155 168 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(24 22 31 / var(--tw-bg-opacity))
}
.xpl-choicelist-heading {
  margin-bottom: 0.5rem
}
.xpl-choicelist-heading > h3 {
  font-size: 0.875rem;
  line-height: 1.25rem;
  --tw-text-opacity: 1;
  color: rgb(48 45 59 / var(--tw-text-opacity))
}
.dark .xpl-choicelist-heading > h3 {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity))
}
.xpl-choicelist-heading > p {
  font-size: 0.75rem;
  line-height: 1rem;
  --tw-text-opacity: 1;
  color: rgb(106 109 125 / var(--tw-text-opacity))
}
.dark .xpl-choicelist-heading > p {
  --tw-text-opacity: 1;
  color: rgb(153 155 168 / var(--tw-text-opacity))
}
.xpl-choicelist {
  margin: 0px;
  display: block;
  padding: 0px
}
.xpl-choicelist li {
  margin-bottom: 1rem
}
/* override default checkbox/radio styling in choicelists */
.xpl-choicelist .xpl-checkbox-radio-container {
  margin-bottom: 0px
}
.xpl-choicelist--styled {
  overflow: hidden;
  border-radius: 0.375rem;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(238 239 243 / var(--tw-border-opacity))
}
.dark .xpl-choicelist--styled {
  --tw-border-opacity: 1;
  border-color: rgb(106 109 125 / var(--tw-border-opacity))
}
.xpl-choicelist--styled .xpl-radio-container,
.xpl-choicelist--styled .xpl-checkbox-container {
  margin-bottom: 0px
}
.xpl-choicelist--styled li {
  position: relative;
  margin-bottom: 0px;
  display: block;
  border-width: 1px;
  border-top-width: 0px;
  border-left-width: 0px;
  border-right-width: 0px;
  --tw-border-opacity: 1;
  border-color: rgb(238 239 243 / var(--tw-border-opacity));
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms
}
.dark .xpl-choicelist--styled li {
  --tw-border-opacity: 1;
  border-color: rgb(106 109 125 / var(--tw-border-opacity))
}
.xpl-choicelist--styled li:last-child {
  border-bottom-width: 0px
}
.xpl-choicelist--styled li.selected {
  --tw-bg-opacity: 1;
  background-color: rgb(244 242 255 / var(--tw-bg-opacity))
}
.dark .xpl-choicelist--styled li.selected {
  --tw-bg-opacity: 1;
  background-color: rgb(54 50 64 / var(--tw-bg-opacity))
}
.xpl-choicelist--styled input {
  position: absolute;
  margin-left: 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem
}
.xpl-choicelist--styled label {
  display: block;
  width: 100%;
  padding-top: 1rem;
  padding-right: 1rem;
  padding-bottom: 1rem
}
.xpl-choicelist--styled .xpl-checkbox + label,
.xpl-choicelist--styled .xpl-radio + label {
  padding-left: 3rem
}
.xpl-content-area-wrapper {
  height: 100%;
  min-width: 0;
  background-color: var(--xpl-color-background-lm);
}
.xpl-content-area-wrapper__wide .xpl-content-area {
  padding: 1.5rem
}
@media (min-width: 768px) {
  .xpl-content-area-wrapper__wide .xpl-content-area {
    padding: 2rem
  }
}
.xpl-content-area-wrapper__narrow {
    grid-template-areas: ". content .";
    grid-template-columns: minmax(15%, auto) minmax(auto, 840px) minmax(15%, auto);
  }
.xpl-content-area-wrapper__narrow .xpl-content-area {
  grid-column: span 1 / span 1;
  grid-column-start: 2;
  padding-top: 5rem;
  padding-bottom: 5rem
}
@media (max-width: 1023px) {
.xpl-content-area-wrapper__narrow .xpl-content-area {
    grid-template-columns: none;
    padding: 0px
  }
.xpl-content-area-wrapper__narrow {
    grid-template-columns: none;
    grid-template-rows: none;
    padding: 1.5rem
  }
      }
.xpl-content-area-wrapper__narrow {
  display: grid;
  grid-auto-flow: column;
  justify-items: center
}
.xpl-content-area-wrapper__full {
  max-width: none;
  padding: 1.5rem
}
@media (min-width: 640px) {
  .xpl-content-area-wrapper__full {
    padding: 2rem
  }
}
@media (min-width: 1024px) {
  .xpl-content-area-wrapper__full {
    padding: 0px
  }
}
.dark .xpl-content-area-wrapper {
  background-color: var(--xpl-color-background-dm);
  color: var(--xpl-color-text-primary-dm);
}
.xpl-dashboard {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem
}
.xpl-data-card {
  background-color: var(--xpl-color-foreground-lm);
  border-color: var(--xpl-color-stroke-lm);
  color: var(--xpl-color-text-primary-lm);
  container-name: card;
  container-type: inline-size;
  flex-basis: 21%;
}
.xpl-data-card__anchor {
  position: absolute;
  top: 0px;
  left: 0px;
  display: block;
  height: 100%;
  width: 100%;
  background-color: transparent
}
.xpl-data-card__anchor span {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0
}
.xpl-data-card__link:focus,
    .xpl-data-card__link:active {
      border-color: var(--xpl-color-secondary-lm);
    }
.xpl-data-card__link:hover {
  cursor: pointer;
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}
.xpl-data-card__header {
  margin-bottom: 0.25rem;
  display: flex;
  max-height: 2rem;
  justify-content: space-between
}
.xpl-data-card__header--primary {
      /* sets the icon color */
      color: var(--xpl-color-primary-lm);
    }
.xpl-data-card__header--secondary {
      color: var(--xpl-color-secondary-lm);
    }
.xpl-data-card__header__arrow {
      color: var(--xpl-color-text-primary-lm);
    }
.xpl-data-card__header--no-icon {
  position: absolute;
  top: 1rem;
  right: 1rem;
  display: flex;
  justify-content: flex-end
}
.xpl-data-card dt {
    font-size: var(--xpl-size-font-title-5);
  }
.xpl-data-card dd {
    font-size: var(--xpl-size-font-title-1);
    font-weight: var(--xpl-font-weight-bold);
    margin-inline-start: 0;
    display: flex;
    flex-direction: column;
  }
.xpl-data-card {
  position: relative;
  display: flex;
  height: -moz-min-content;
  height: min-content;
  max-width: 50%;
  flex-grow: 1;
  flex-direction: column-reverse;
  overflow: hidden;
  border-radius: 0.375rem;
  border-width: 1px;
  padding: 1rem
}
.dark .xpl-data-card {
  background-color: var(--xpl-color-foreground-dm);
  border-color: var(--xpl-color-stroke-dm);
  color: var(--xpl-color-text-primary-dm);
}
.dark .xpl-data-card__header--primary {
  color: var(--xpl-color-primary-dm);
}
.dark .xpl-data-card__header--secondary {
  color: var(--xpl-color-secondary-dm);
}
.dark .xpl-data-card__header__arrow {
  color: var(--xpl-color-text-primary-dm);
}
.dark .xpl-data-card__link:focus,
.dark .xpl-data-card__link:active {
  border-color: var(--xpl-color-secondary-dm);
}
@media (max-width: 640px) {
  .xpl-data-card {
    flex-basis: 42%;
  }
}
@container card (max-width: 212px) {
  .xpl-data-card dd {
    font-size: var(--xpl-size-font-title-2);
  }
}
@container card (max-width: 441px) {
  .xpl-data-card__long_stat {
    display: none
  }
.flatpickr-day.xpl-data-card__long_stat{visibility:hidden}
}
@container card (min-width: 441px) {
  .xpl-data-card__short_stat {
    display: none
  }
.flatpickr-day.xpl-data-card__short_stat{visibility:hidden}
}
.xpl-data-card__short_stat abbr[title] {
    text-decoration: none;
  }
.dark .xpl-divider {
  --tw-border-opacity: 1;
  border-color: rgb(106 109 125 / var(--tw-border-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity))
}
.xpl-divider {
  margin-bottom: 1rem;
  display: block;
  border-bottom-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(225 226 232 / var(--tw-border-opacity));
  padding-bottom: 0.25rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  --tw-text-opacity: 1;
  color: rgb(48 45 59 / var(--tw-text-opacity))
}
.xpl-divider--3 {
  font-size: 1.25rem;
  line-height: 1.75rem;
  font-weight: 700
}
.xpl-divider--2 {
  font-size: 1rem;
  line-height: 1.5rem
}
.xpl-divider--1 {
  font-size: 0.75rem;
  line-height: 1rem
}
.xpl-divider--0 span {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0
}
.xpl-divider--0 {
  padding-bottom: 0px
}
.xpl-dropdown {
  pointer-events: none;
  position: absolute;
  width: 100%;
  --tw-translate-y: -0.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  overflow: hidden;
  border-radius: 0.375rem;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(225 226 232 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  opacity: 0;
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms
}
.dark .xpl-dropdown {
  --tw-border-opacity: 1;
  border-color: rgb(106 109 125 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(48 45 59 / var(--tw-bg-opacity))
}
.xpl-dropdown--open {
  pointer-events: auto;
  z-index: 50;
  --tw-translate-y: 0.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  opacity: 1
}
.xpl-dropdown-list {
  max-height: 300px;
  height: 100%;
  overflow-y: auto;
}
.xpl-dropdown-list-item {
  list-style: none;
}
.dark .xpl-dropdown-option {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity))
}
.xpl-dropdown-option:not(.xpl-dropdown-option--disabled):focus {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
  outline: 2px solid transparent;
  outline-offset: 2px
}
.xpl-dropdown-option:not(.xpl-dropdown-option--disabled):hover {
      background-color: var(--xpl-color-secondary-bg-lm);
    }
.xpl-dropdown-option--disabled,
    .xpl-dropdown-option--disabled [disabled] {
      touch-action: none;
      pointer-events: none;
    }
.xpl-dropdown-option--disabled {
  cursor: not-allowed;
  opacity: 0.6
}
.xpl-dropdown-option--selected {
    background-color: var(--xpl-color-secondary-bg-lm);
    border-right: 4px solid var(--xpl-color-secondary-lm);
  }
.dark .xpl-dropdown-option:not(.xpl-dropdown-option--disabled):focus {
  --tw-bg-opacity: 1;
  background-color: rgb(41 38 50 / var(--tw-bg-opacity));
  outline: 2px solid transparent;
  outline-offset: 2px
}
.dark .xpl-dropdown-option:not(.xpl-dropdown-option--disabled):hover {
  --tw-bg-opacity: 1;
  background-color: rgb(24 22 31 / var(--tw-bg-opacity))
}
.dark .xpl-dropdown-option--selected {
    border-right: 4px solid var(--xpl-color-secondary-dm);
    --tw-bg-opacity: 1;
    background-color: rgb(24 22 31 / var(--tw-bg-opacity));
  }
.xpl-dropdown-option {
  display: block;
  width: 100%;
  cursor: pointer;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  text-align: left;
  font-size: 0.875rem;
  line-height: 1.25rem;
  --tw-text-opacity: 1;
  color: rgb(48 45 59 / var(--tw-text-opacity))
}
.xpl-dropdown.xpl-dropdown--multi .xpl-dropdown-option--selected {
  background-image: url("data:image/svg+xml,%3Csvg width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12 6C12 9.31372 9.31372 12 6 12C2.68628 12 0 9.31372 0 6C0 2.68628 2.68628 0 6 0C9.31372 0 12 2.68628 12 6ZM5.30598 9.17695L9.7576 4.72534C9.90876 4.57418 9.90876 4.32907 9.7576 4.17791L9.21017 3.63048C9.05901 3.4793 8.8139 3.4793 8.66272 3.63048L5.03226 7.26092L3.33728 5.56594C3.18612 5.41478 2.94102 5.41478 2.78983 5.56594L2.2424 6.11337C2.09124 6.26453 2.09124 6.50964 2.2424 6.6608L4.75853 9.17693C4.90972 9.32811 5.1548 9.32811 5.30598 9.17695V9.17695Z' fill='%236923F4'/%3E%3C/svg%3E%0A");
  background-position: calc(100% - 16px) center;
  background-repeat: no-repeat;
}
.dark .xpl-dropdown.xpl-dropdown--multi .xpl-dropdown-option--selected {
    background-image: url("data:image/svg+xml,%3Csvg width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12 6C12 9.31372 9.31372 12 6 12C2.68628 12 0 9.31372 0 6C0 2.68628 2.68628 0 6 0C9.31372 0 12 2.68628 12 6ZM5.30598 9.17695L9.7576 4.72534C9.90876 4.57418 9.90876 4.32907 9.7576 4.17791L9.21017 3.63048C9.05901 3.4793 8.8139 3.4793 8.66272 3.63048L5.03226 7.26092L3.33728 5.56594C3.18612 5.41478 2.94102 5.41478 2.78983 5.56594L2.2424 6.11337C2.09124 6.26453 2.09124 6.50964 2.2424 6.6608L4.75853 9.17693C4.90972 9.32811 5.1548 9.32811 5.30598 9.17695V9.17695Z' fill='%23C3ADFF'/%3E%3C/svg%3E%0A");
  }
.xpl-dropdown.xpl-dropdown--multi .xpl-dropdown-option--selected {
  border-width: 0px
}
.dark .xpl-dropdown-heading {
  --tw-border-opacity: 1;
  border-color: rgb(106 109 125 / var(--tw-border-opacity));
  --tw-text-opacity: 1;
  color: rgb(153 155 168 / var(--tw-text-opacity))
}
.xpl-dropdown-heading {
  display: block;
  width: 100%;
  border-bottom-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(225 226 232 / var(--tw-border-opacity));
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  font-size: 0.75rem;
  line-height: 1rem;
  --tw-text-opacity: 1;
  color: rgb(106 109 125 / var(--tw-text-opacity))
}
/* Flatpickr overrides */
[class^="flatpickr-"] {
  font-family: var(--xpl-font-family-default);
}
.flatpickr-calendar {
  border: 1px solid #e1e2e8;
  box-shadow: 0 4px 6px -2px #0000000d, 0 10px 15px -3px #0000001a;
}
@keyframes fpFadeInDown {
  from {
    opacity: 0;
    transform: translate3d(-13px, -20px, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(-13px, 8px, 0);
  }
}
.flatpickr-calendar.animate.arrowTop {
  transform: translate3d(-13px, 8px, 0);
}
@keyframes fpFadeInDownAdjust {
  from {
    opacity: 0;
    transform: translate3d(-13px, -28px, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(-13px, -8px, 0);
  }
}
.flatpickr-calendar.animate.arrowBottom {
  animation-name: fpFadeInDownAdjust;
  transform: translate3d(-13px, -8px, 0);
}
.dark .flatpickr-calendar {
  border-color: #302d3b;
  box-shadow: 0 4px 6px -2px #0000000d, 0 10px 15px -3px #0000001a;
  --tw-bg-opacity: 1;
  background-color: rgb(60 56 71 / var(--tw-bg-opacity));
}
.flatpickr-calendar::before,
.flatpickr-calendar::after {
  display: none !important;
}
.flatpickr-months {
  padding: 0.5rem
}
.flatpickr-months .flatpickr-month {
  height: 40px;
  --tw-bg-opacity: 1;
  background-color: rgb(248 249 250 / var(--tw-bg-opacity));
}
.dark .flatpickr-months .flatpickr-month {
  --tw-bg-opacity: 1;
  background-color: rgb(54 50 64 / var(--tw-bg-opacity))
}
.flatpickr-months .flatpickr-prev-month.flatpickr-prev-month,
.flatpickr-months .flatpickr-next-month.flatpickr-prev-month {
  left: 75%;
}
.flatpickr-months .flatpickr-prev-month,
.flatpickr-months .flatpickr-next-month {
  box-sizing: border-box; /* don't know why this gets unset :-\ */
  height: 40px;
  top: 0.5rem;
  padding-top: 0.75rem;
}
.flatpickr-months .flatpickr-prev-month.flatpickr-next-month,
.flatpickr-months .flatpickr-next-month.flatpickr-next-month {
  right: 0.5rem
}
.flatpickr-months .flatpickr-prev-month:hover,
.flatpickr-months .flatpickr-next-month:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity))
}
.dark .flatpickr-months .flatpickr-prev-month,
.dark .flatpickr-months .flatpickr-next-month {
  fill: var(--xpl-color-text-primary-dm);
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.dark .flatpickr-months .flatpickr-prev-month:hover,
.dark .flatpickr-months .flatpickr-next-month:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(41 38 50 / var(--tw-bg-opacity))
}
.flatpickr-months .flatpickr-prev-month svg path,
.flatpickr-months .flatpickr-next-month svg path {
  fill: var(--xpl-color-text-primary-lm);
}
.flatpickr-months .flatpickr-prev-month:hover path,
.flatpickr-months .flatpickr-next-month:hover path {
  fill: var(--xpl-color-secondary-lm);
}
.dark .flatpickr-months .flatpickr-prev-month svg path,
.dark .flatpickr-months .flatpickr-next-month svg path {
  fill: #fff;
}
.dark .flatpickr-months .flatpickr-prev-month:hover path,
.dark .flatpickr-months .flatpickr-next-month:hover path {
  fill: var(--xpl-color-secondary-dm);
}
.flatpickr-current-month {
  font-size: 100%;
  height: 40px;
  left: 0px;
  padding: 0px;
  text-align: left;
  font-size: 1rem;
  line-height: 1.5rem;
}
.flatpickr-current-month .flatpickr-monthDropdown-months {
  font-weight: 500;
  height: 40px;
  margin: 0px;
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  padding: 0.5rem;
}
.flatpickr-current-month .numInputWrapper {
  width: 64px;
}
.flatpickr-current-month .flatpickr-monthDropdown-months:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity))
}
.flatpickr-current-month input.cur-year {
  font-weight: 500;
  height: 40px;
  padding: 0.5rem;
  padding-right: 1rem;
}
.numInputWrapper:hover,
.flatpickr-current-month input.cur-year:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity))
}
.numInputWrapper span {
  border-width: 0px
}
.numInputWrapper span:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(238 239 243 / var(--tw-bg-opacity))
}
.flatpickr-current-month .flatpickr-monthDropdown-months option {
  --tw-text-opacity: 1;
  color: rgb(48 45 59 / var(--tw-text-opacity))
}
.dark .flatpickr-current-month .flatpickr-monthDropdown-months option {
  color: #fff;
}
.dark .flatpickr-current-month input.cur-year {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity))
}
.dark .numInputWrapper:hover,
.dark .flatpickr-current-month input.cur-year:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(41 38 50 / var(--tw-bg-opacity))
}
.flatpickr-current-month .numInputWrapper span.arrowUp::after {
  bottom: 4px;
  top: unset;
}
.flatpickr-current-month .numInputWrapper span.arrowDown::after {
  top: 4px;
}
.dark .flatpickr-current-month .numInputWrapper span.arrowUp::after,
.dark .flatpickr-current-month .numInputWrapper span.arrowDown::after {
  border-bottom-color: var(--xpl-color-text-primary-dm);
}
.dark .flatpickr-current-month .flatpickr-monthDropdown-months {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity))
}
.dark .flatpickr-current-month .flatpickr-monthDropdown-months:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(41 38 50 / var(--tw-bg-opacity))
}
.flatpickr-day {
  line-height: 2.3rem;
}
.rangeMode .flatpickr-day {
  margin-top: 0px
}
.flatpickr-day.selected,
.flatpickr-day.startRange,
.flatpickr-day.endRange,
.flatpickr-day.selected.inRange,
.flatpickr-day.startRange.inRange,
.flatpickr-day.endRange.inRange,
.flatpickr-day.selected:focus,
.flatpickr-day.startRange:focus,
.flatpickr-day.endRange:focus,
.flatpickr-day.selected:hover,
.flatpickr-day.startRange:hover,
.flatpickr-day.endRange:hover,
.flatpickr-day.selected.prevMonthDay,
.flatpickr-day.startRange.prevMonthDay,
.flatpickr-day.endRange.prevMonthDay,
.flatpickr-day.selected.nextMonthDay,
.flatpickr-day.startRange.nextMonthDay,
.flatpickr-day.endRange.nextMonthDay {
  background-color: var(--xpl-color-secondary-lm);
  border-color: var(--xpl-color-secondary-lm);
}
.dark .flatpickr-day.selected, .dark .flatpickr-day.startRange, .dark .flatpickr-day.endRange, .dark .flatpickr-day.selected.inRange, .dark .flatpickr-day.startRange.inRange, .dark .flatpickr-day.endRange.inRange, .dark .flatpickr-day.selected:focus, .dark .flatpickr-day.startRange:focus, .dark .flatpickr-day.endRange:focus, .dark .flatpickr-day.selected:hover, .dark .flatpickr-day.startRange:hover, .dark .flatpickr-day.endRange:hover, .dark .flatpickr-day.selected.prevMonthDay, .dark .flatpickr-day.startRange.prevMonthDay, .dark .flatpickr-day.endRange.prevMonthDay, .dark .flatpickr-day.selected.nextMonthDay, .dark .flatpickr-day.startRange.nextMonthDay, .dark .flatpickr-day.endRange.nextMonthDay {
    background-color: var(--xpl-color-secondary-dm);
    border-color: var(--xpl-color-secondary-dm);
    color: var(--xpl-color-text-reverse-dm);
  }
.flatpickr-day.inRange,
.flatpickr-day.prevMonthDay.inRange,
.flatpickr-day.nextMonthDay.inRange,
.flatpickr-day.today.inRange,
.flatpickr-day.prevMonthDay.today.inRange,
.flatpickr-day.nextMonthDay.today.inRange,
.flatpickr-day:hover,
.flatpickr-day.prevMonthDay:hover,
.flatpickr-day.nextMonthDay:hover,
.flatpickr-day:focus,
.flatpickr-day.prevMonthDay:focus,
.flatpickr-day.nextMonthDay:focus {
  background-color: var(--xpl-color-secondary-bg-lm);
  border-color: var(--xpl-color-secondary-bg-lm);
}
.flatpickr-day.inRange {
  box-shadow: -5px 0 0 var(--xpl-color-secondary-bg-lm), 5px 0 0 var(--xpl-color-secondary-bg-lm);
}
.dark .flatpickr-day.inRange {
    box-shadow: -5px 0 0 var(--xpl-color-secondary-bg-dm), 5px 0 0 var(--xpl-color-secondary-bg-dm);
  }
.dark .flatpickr-day {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity))
}
.dark .flatpickr-day.inRange,
.dark .flatpickr-day.prevMonthDay.inRange,
.dark .flatpickr-day.nextMonthDay.inRange,
.dark .flatpickr-day.today.inRange,
.dark .flatpickr-day.prevMonthDay.today.inRange,
.dark .flatpickr-day.nextMonthDay.today.inRange,
.dark .flatpickr-day:hover,
.dark .flatpickr-day.prevMonthDay:hover,
.dark .flatpickr-day.nextMonthDay:hover,
.dark .flatpickr-day:focus,
.dark .flatpickr-day.prevMonthDay:focus,
.dark .flatpickr-day.nextMonthDay:focus {
  background-color: var(--xpl-color-secondary-bg-dm);
  border-color: var(--xpl-color-secondary-bg-dm);
  color: var(--xpl-color-secondary-dm);
}
.flatpickr-day.selected.startRange + .endRange:not(:nth-child(7n+1)),
.flatpickr-day.startRange.startRange + .endRange:not(:nth-child(7n+1)),
.flatpickr-day.endRange.startRange + .endRange:not(:nth-child(7n+1)) {
  box-shadow: -10px 0 0 var(--xpl-color-secondary-bg-lm);
}
.dark .flatpickr-day.selected.startRange + .endRange:not(:nth-child(7n+1)),
.dark .flatpickr-day.startRange.startRange + .endRange:not(:nth-child(7n+1)),
.dark .flatpickr-day.endRange.startRange + .endRange:not(:nth-child(7n+1)) {
  box-shadow: -10px 0 0 var(--xpl-color-secondary-bg-dm);
}
span.flatpickr-weekday {
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 400;
  --tw-text-opacity: 1;
  color: rgb(48 45 59 / var(--tw-text-opacity))
}
.dark span.flatpickr-weekday {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity))
}
.xpl-grid {
  display: flex;
  width: 100%;
  flex-wrap: wrap
}
.xpl-grid-item {
  margin-right: 1.5rem;
  margin-bottom: 1.5rem;
  flex-shrink: 0
}
@media screen and (max-width: 639px) {
  .xpl-grid-item-xs-1 {
    flex: 0 0 calc(16.667% - 20px);
  }

  .xpl-grid-item-xs-2 {
    flex: 0 0 calc(33.333% - 16px);
  }

  .xpl-grid-item-xs-3 {
    flex: 0 0 calc(50% - 12px);
  }

  .xpl-grid-item-xs-4 {
    flex: 0 0 calc(66.667% - 8px);
  }

  .xpl-grid-item-xs-5 {
    flex: 0 0 calc(83.333% - 4px);
  }

  .xpl-grid-item-xs-6 {
    flex: 0 0 100%;
  }

  .xpl-grid-item-xs-last {
    margin-right: 0px
  }
}
@media screen and (min-width: 640px) and (max-width: 1023px) {
  .xpl-grid-item-sm-1 {
    flex: 0 0 calc(16.667% - 20px);
  }

  .xpl-grid-item-sm-2 {
    flex: 0 0 calc(33.333% - 16px);
  }

  .xpl-grid-item-sm-3 {
    flex: 0 0 calc(50% - 12px);
  }

  .xpl-grid-item-sm-4 {
    flex: 0 0 calc(66.667% - 8px);
  }

  .xpl-grid-item-sm-5 {
    flex: 0 0 calc(83.333% - 4px);
  }

  .xpl-grid-item-sm-6 {
    flex: 0 0 100%;
  }

  .xpl-grid-item-sm-last {
    margin-right: 0px
  }
}
@media screen and (min-width: 1024px) and (max-width: 1279px) {
  .xpl-grid-item-md-1 {
    flex: 0 0 calc(16.667% - 20px);
  }

  .xpl-grid-item-md-2 {
    flex: 0 0 calc(33.333% - 16px);
  }

  .xpl-grid-item-md-3 {
    flex: 0 0 calc(50% - 12px);
  }

  .xpl-grid-item-md-4 {
    flex: 0 0 calc(66.667% - 8px);
  }

  .xpl-grid-item-md-5 {
    flex: 0 0 calc(83.333% - 4px);
  }

  .xpl-grid-item-md-6 {
    flex: 0 0 100%;
  }

  .xpl-grid-item-md-last {
    margin-right: 0px
  }
}
@media screen and (min-width: 1280px) {
  .xpl-grid-item-lg-1 {
    flex: 0 0 calc(16.667% - 20px);
  }

  .xpl-grid-item-lg-2 {
    flex: 0 0 calc(33.333% - 16px);
  }

  .xpl-grid-item-lg-3 {
    flex: 0 0 calc(50% - 12px);
  }

  .xpl-grid-item-lg-4 {
    flex: 0 0 calc(66.667% - 8px);
  }

  .xpl-grid-item-lg-5 {
    flex: 0 0 calc(83.333% - 4px);
  }

  .xpl-grid-item-lg-6 {
    flex: 0 0 100%;
  }

  .xpl-grid-item-lg-last {
    margin-right: 0px
  }
}
.xpl-icon__wrapper {
  margin: 0px
}
.xpl-icon__wrapper--with-background--orange {
      background-color: var(--xpl-color-orange-50);
    }
.xpl-icon__wrapper--with-background--purple {
      background-color: var(--xpl-color-purple-50);
    }
.xpl-icon__wrapper--with-background--red {
      background-color: var(--xpl-color-red-50);
    }
.xpl-icon__wrapper--with-background--yellow {
      background-color: var(--xpl-color-yellow-50);
    }
.xpl-icon__wrapper--with-background--gray {
      background-color: var(--xpl-color-gray-50);
    }
.xpl-icon__wrapper--with-background {
  border-radius: 0.375rem;
  padding: 0.25rem
}
.xpl-icon__wrapper figcaption {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0
}
.dark .xpl-icon__wrapper--with-background--orange {
  background-color: var(--xpl-color-orange-900);
}
.dark .xpl-icon__wrapper--with-background--purple {
  background-color: var(--xpl-color-purple-900);
}
.dark .xpl-icon__wrapper--with-background--red {
  background-color: var(--xpl-color-red-900);
}
.dark .xpl-icon__wrapper--with-background--yellow {
  background-color: var(--xpl-color-yellow-900);
}
.dark .xpl-icon__wrapper--with-background--gray {
  background-color: var(--xpl-color-gray-900);
}
.xpl-input {
  position: relative;
  display: block
}
.xpl-input input {
  height: 44px;
  display: block;
  width: 100%;
  overflow: hidden;
  background-color: transparent;
  padding-right: 0.5rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.xpl-input-calendar {
  pointer-events: none;
  position: absolute;
  right: 0.75rem
}
button[class^="xpl-input-password"] {
  position: absolute;
  top: 0px;
  right: 0px;
  height: 100%;
  cursor: pointer;
  padding-left: 0.75rem;
  padding-right: 0.75rem
}
.xpl-input-calendar path,
[class^="xpl-input-password"] path {
  fill: var(--xpl-color-text-primary-lm);
}
.xpl-input-error path {
  fill: var(--xpl-color-text-warning-lm);
}
.dark .xpl-input-calendar path,
.dark [class^="xpl-input-password"] path {
  fill: #fff;
}
.xpl-input textarea {
  min-height: 44px;
  height: 98px;
  display: block;
  width: 100%;
  overflow: hidden;
  background-color: transparent;
  padding-top: 0.75rem;
  padding-bottom: 0.5rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.dark .xpl-input input,
.dark .xpl-input textarea {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity))
}
.xpl-input input:-moz-read-only, .xpl-input textarea:-moz-read-only {
  --tw-border-opacity: 1;
  border-color: rgb(248 249 250 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(248 249 250 / var(--tw-bg-opacity))
}
.xpl-input input:read-only,
.xpl-input textarea:read-only {
  --tw-border-opacity: 1;
  border-color: rgb(248 249 250 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(248 249 250 / var(--tw-bg-opacity))
}
.xpl-input input:read-only:not(:disabled)::-moz-placeholder, .xpl-input textarea:read-only:not(:disabled)::-moz-placeholder {
  color: var(--xpl-color-text-primary-lm);
}
.xpl-input input:-moz-read-only:not(:disabled)::placeholder, .xpl-input textarea:-moz-read-only:not(:disabled)::placeholder {
  color: var(--xpl-color-text-primary-lm);
}
.xpl-input input:read-only:not(:disabled)::placeholder,
.xpl-input textarea:read-only:not(:disabled)::placeholder {
  color: var(--xpl-color-text-primary-lm);
}
.xpl-input input:disabled,
.xpl-input textarea:disabled {
  cursor: not-allowed;
  background-color: transparent
}
.xpl-input-label {
  display: block;
  cursor: pointer;
  padding-bottom: 0.25rem;
  font-size: 0.875rem;
  line-height: 1.25rem
}
.dark .xpl-input-label {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity))
}
.xpl-input-label small {
  display: block;
  font-size: 0.75rem;
  line-height: 1rem;
  --tw-text-opacity: 1;
  color: rgb(106 109 125 / var(--tw-text-opacity))
}
.dark .xpl-input-label small {
  --tw-text-opacity: 1;
  color: rgb(153 155 168 / var(--tw-text-opacity))
}
.xpl-input--disabled .xpl-input-label {
  cursor: not-allowed
}
.xpl-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  overflow: hidden;
  border-radius: 0.375rem;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(225 226 232 / var(--tw-border-opacity));
  padding-left: 0.75rem
}
.xpl-input-wrapper:focus-within {
  border-color: var(--xpl-color-secondary-lm);
}
.xpl-input--disabled .xpl-input-wrapper {
  cursor: not-allowed;
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity))
}
.dark .xpl-input-wrapper {
  --tw-border-opacity: 1;
  border-color: rgb(106 109 125 / var(--tw-border-opacity))
}
.xpl-input--error .xpl-input-wrapper {
  --tw-border-opacity: 1;
  border-color: rgb(219 50 31 / var(--tw-border-opacity))
}
.dark .xpl-input--disabled .xpl-input-wrapper {
  --tw-bg-opacity: 1;
  background-color: rgb(54 50 64 / var(--tw-bg-opacity))
}
.dark .xpl-input--error .xpl-input-wrapper {
  --tw-border-opacity: 1;
  border-color: rgb(255 147 135 / var(--tw-border-opacity))
}
.xpl-input-wrapper label {
  color: var(--xpl-color-text-secondary-lm);
  top: 9px;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.dark .xpl-input-wrapper label {
  color: var(--xpl-color-text-secondary-dm);
}
.xpl-input-wrapper label.xpl-input-pre {
  flex-shrink: 0;
  padding-left: 0px
}
.xpl-input-wrapper label.xpl-input-post {
  border-left-width: 1px;
  line-height: 2.75rem;
  left: auto;
  right: 0.75rem;
  height: 2.75rem;
  flex-shrink: 0;
  --tw-border-opacity: 1;
  border-color: rgb(225 226 232 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(248 249 250 / var(--tw-bg-opacity));
}
.dark .xpl-input-wrapper label.xpl-input-post {
  --tw-border-opacity: 1;
  border-color: rgb(106 109 125 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(60 56 71 / var(--tw-bg-opacity))
}
.dark .xpl-input-wrapper:focus-within {
  border-color: var(--xpl-color-secondary-dm);
}
.xpl-input-characters {
  background-color: #fffd;
  pointer-events: none;
  position: absolute;
  bottom: 0px;
  right: 0px;
  display: block;
  padding-bottom: 0.5rem;
  padding-top: 0.5rem;
  padding-right: 0.75rem;
  padding-left: 0.75rem;
  font-size: 0.75rem;
  line-height: 1rem;
  --tw-text-opacity: 1;
  color: rgb(106 109 125 / var(--tw-text-opacity));
}
.dark .xpl-input-characters {
  background-color: #fff4;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.xpl-input--disabled .xpl-input-characters {
  background-color: transparent
}
.xpl-input--error .xpl-input-characters {
  --tw-text-opacity: 1;
  color: rgb(194 33 15 / var(--tw-text-opacity))
}
.dark .xpl-input--error .xpl-input-characters {
  --tw-text-opacity: 1;
  color: rgb(255 147 135 / var(--tw-text-opacity))
}
.xpl-input-error {
  display: block;
  padding-top: 0.25rem;
  text-align: right;
  font-size: 0.75rem;
  line-height: 1rem;
  --tw-text-opacity: 1;
  color: rgb(194 33 15 / var(--tw-text-opacity))
}
.dark .xpl-input-error {
  --tw-text-opacity: 1;
  color: rgb(255 147 135 / var(--tw-text-opacity))
}
.xpl-input-error svg {
  top: 1px;
  position: relative;
  margin-right: 0.5rem;
}
.dark .xpl-input-error path {
  fill: var(--xpl-color-text-warning-dm);
}
.xpl-label {
  display: block;
  width: 100%;
  cursor: pointer;
  padding-bottom: 0.25rem;
  font-size: 0.875rem;
  line-height: 1.25rem
}
.xpl-label--disabled {
  cursor: not-allowed !important;
  --tw-text-opacity: 1;
  color: rgb(106 109 125 / var(--tw-text-opacity));
}
small.xpl-description {
  display: block;
  font-size: 0.75rem;
  line-height: 1rem;
  --tw-text-opacity: 1;
  color: rgb(106 109 125 / var(--tw-text-opacity))
}
.xpl-description--disabled {
  cursor: not-allowed !important;
  --tw-text-opacity: 1;
  color: rgb(106 109 125 / var(--tw-text-opacity));
}
.dark .xpl-label {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity))
}
.dark .xpl-label--disabled {
  --tw-text-opacity: 1;
  color: rgb(153 155 168 / var(--tw-text-opacity))
}
.dark .xpl-description {
  --tw-text-opacity: 1;
  color: rgb(153 155 168 / var(--tw-text-opacity))
}
.dark .xpl-description--disabled {
  --tw-text-opacity: 1;
  color: rgb(153 155 168 / var(--tw-text-opacity))
}
.xpl-list-item {
  margin-bottom: 1.5rem;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  border-radius: 0.375rem;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(225 226 232 / var(--tw-border-opacity));
  padding: 1rem;
  text-align: left;
  font-size: 0.875rem;
  line-height: 1.25rem;
  --tw-text-opacity: 1;
  color: rgb(48 45 59 / var(--tw-text-opacity));
  text-decoration-line: none
}
.dark .xpl-list-item {
  --tw-border-opacity: 1;
  border-color: rgb(106 109 125 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(48 45 59 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity))
}
.xpl-list-left {
  margin-right: 2rem;
  display: flex;
  flex-shrink: 0
}
.xpl-list-right div:not(:last-child) {
  margin-bottom: 0.25rem
}
a.xpl-list-item {
  background-image: url("data:image/svg+xml,%3Csvg width='8' height='12' viewBox='0 0 8 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M7.44187 6.3187L1.93773 11.8678C1.76151 12.0441 1.47655 12.0441 1.30033 11.8678L0.557948 11.1254C0.381726 10.9492 0.381726 10.6643 0.557948 10.488L5.001 6L0.557948 1.51195C0.381726 1.33573 0.381726 1.05077 0.557948 0.874551L1.30033 0.132167C1.47655 -0.0440556 1.76151 -0.0440556 1.93773 0.132167L7.44187 5.6813C7.6181 5.85752 7.6181 6.14248 7.44187 6.3187Z' fill='%236A6D7D'/%3E%3C/svg%3E%0A");
  background-repeat: no-repeat;
  background-position: calc(100% - 1rem) center;
  padding-right: 2.25rem;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
a.xpl-list-item:hover {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}
.dark a.xpl-list-item {
  background-image: url("data:image/svg+xml,%3Csvg width='8' height='12' viewBox='0 0 8 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M7.44187 6.3187L1.93773 11.8678C1.76151 12.0441 1.47655 12.0441 1.30033 11.8678L0.557948 11.1254C0.381726 10.9492 0.381726 10.6643 0.557948 10.488L5.001 6L0.557948 1.51195C0.381726 1.33573 0.381726 1.05077 0.557948 0.874551L1.30033 0.132167C1.47655 -0.0440556 1.76151 -0.0440556 1.93773 0.132167L7.44187 5.6813C7.6181 5.85752 7.6181 6.14248 7.44187 6.3187Z' fill='%23999BA8'/%3E%3C/svg%3E%0A");
}
a.xpl-list-item:focus {
  border-color: var(--xpl-color-secondary-lm);
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.dark a.xpl-list-item:focus {
  border-color: var(--xpl-color-secondary-dm);
}
.xpl-list-item:last-child {
  margin-bottom: 0px
}
.xpl-list-item xpl-avatar {
  margin-right: 1rem;
  flex-shrink: 0
}
.xpl-list-item-content {
  display: flex;
  flex-grow: 1;
  align-items: center;
  justify-content: space-between
}
.xpl-list-item-metadata {
  margin: 0px;
  display: flex;
  list-style-type: none;
  padding: 0px
}
.xpl-list-item-metadata li {
  margin-right: 1rem;
  display: inline-flex;
  font-size: 0.75rem;
  line-height: 1rem;
  --tw-text-opacity: 1;
  color: rgb(106 109 125 / var(--tw-text-opacity))
}
.dark .xpl-list-item-metadata li {
  --tw-text-opacity: 1;
  color: rgb(153 155 168 / var(--tw-text-opacity))
}
.xpl-list-item-metadata li:last-child {
  margin-right: 0px
}
.xpl-list-item-subtext {
  --tw-text-opacity: 1;
  color: rgb(106 109 125 / var(--tw-text-opacity))
}
.dark .xpl-list-item-subtext {
  --tw-text-opacity: 1;
  color: rgb(153 155 168 / var(--tw-text-opacity))
}
.xpl-list-item .xpl-avatar--group {
  justify-content: flex-end
}
.xpl-list-item xpl-badge {
  margin-right: 0.5rem
}
@media screen and (max-width: 640px) {
  .xpl-list-item {
    align-items: flex-start
  }

  .xpl-list-item-content {
    display: block
  }

  ul.xpl-list-item-metadata {
    margin-bottom: 0.25rem
  }

  .xpl-list-item-metadata li {
    display: block
  }

  .xpl-list-item .xpl-avatar--group {
    justify-content: flex-start
  }
}
/* stylelint-disable no-descending-specificity, because the rule was expecting some of the code below to appear before some code that is nested above. */
.xpl-main-nav {
  width: 240px;
}
.xpl-main-nav .xpl-main-nav__main_section .xpl-nav-item:last-of-type a,
      .xpl-main-nav .xpl-main-nav__main_section .xpl-nav-item:last-of-type button {
        margin-bottom: 74px;
      }
@media (max-width: 639px) {
.xpl-main-nav .xpl-main-nav__main_section {
    overflow-y: auto
  }
    }
.xpl-main-nav nav {
    grid-template-rows: 74px 1fr min-content;
    background-color: var(--xpl-color-navigation-dm);
    display: grid;
    height: 100%;
  }
@media (max-width: 639px) {
.xpl-main-nav nav {
    overflow-y: auto
  }
    }
.xpl-main-nav .xpl-nav-item a:not(.xpl-dropdown-list *), .xpl-main-nav .xpl-nav-item button:not(.xpl-dropdown-list *) {
        width: 240px;
      }
/* Brand Section */
.xpl-main-nav header {
    grid-template-columns: max-content auto;
  }
.xpl-main-nav header p {
      color: var(--xpl-color-text-primary-dm);
      margin-left: 1rem;
      display: grid;
      align-content: center;
      font-size: 1rem;
      line-height: 1.5rem;
      font-weight: 600;
    }
.xpl-main-nav header img {
      height: 42px;
      width: 42px;
      border-radius: 0.5rem;
    }
.xpl-main-nav header {
  margin-bottom: 0.5rem;
  display: flex;
  align-items: center;
  padding: 1rem
}
.xpl-main-nav footer {
    background-color: var(--xpl-color-background-2-dm);
  }
.xpl-main-nav footer .xpl-avatar {
  margin-right: 1rem
}
.xpl-main-nav footer div p {
  font-size: 0.875rem;
  line-height: 1.25rem
}
.xpl-main-nav footer div p:first-of-type {
        color: var(--xpl-color-text-primary-dm);
      }
.xpl-main-nav footer div {
  overflow-x: auto
}
.xpl-main-nav footer .xpl-nav-item a svg, .xpl-main-nav footer .xpl-nav-item button svg {
          color: var(--xpl-color-text-secondary-dm);
          fill: currentColor;
        }
.xpl-main-nav footer {
  z-index: 20;
  display: grid;
  align-items: flex-end;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem
}
/* Width for different screen sizes */
.xpl-main-nav--md .xpl-nav-item a,
      .xpl-main-nav--md .xpl-nav-item button {
        width: 112px;
      }
.xpl-main-nav--md .xpl-nav-item a svg, .xpl-main-nav--md .xpl-nav-item button svg {
  margin-right: 0px
}
.xpl-main-nav--md .xpl-nav-item a,
      .xpl-main-nav--md .xpl-nav-item button {
  display: grid;
  grid-auto-flow: row;
  justify-items: center
}
.xpl-main-nav--sm .xpl-nav-item a,
      .xpl-main-nav--sm .xpl-nav-item button {
        width: 74px;
      }
.xpl-main-nav--sm .xpl-nav-item a p, .xpl-main-nav--sm .xpl-nav-item button p {
  display: none
}
.flatpickr-day.xpl-main-nav--sm .xpl-nav-item a p,.flatpickr-day .xpl-main-nav--sm .xpl-nav-item button p{visibility:hidden}
.xpl-main-nav--sm .xpl-nav-item a svg, .xpl-main-nav--sm .xpl-nav-item button svg {
  margin-right: 0px
}
.xpl-main-nav--sm .xpl-nav-item a,
      .xpl-main-nav--sm .xpl-nav-item button {
  display: grid;
  grid-auto-flow: row;
  justify-items: center
}
.xpl-main-nav--sm .xpl-nav-item a,
      .xpl-main-nav--sm .xpl-nav-item button,
      .xpl-main-nav--md .xpl-nav-item a,
      .xpl-main-nav--md .xpl-nav-item button {
        font-size: 0.875rem;
        line-height: 1rem;
        padding-top: 0.75rem;
        padding-bottom: 0.75rem;
        font-weight: 600;
      }
.xpl-main-nav--sm header p, .xpl-main-nav--md header p {
  display: none
}
.flatpickr-day.xpl-main-nav--sm header p,.flatpickr-day .xpl-main-nav--md header p{visibility:hidden}
.xpl-main-nav--sm header, .xpl-main-nav--md header {
  margin-top: 1rem;
  align-content: center;
  justify-content: center
}
.xpl-main-nav--sm footer .xpl-avatar, .xpl-main-nav--md footer .xpl-avatar {
  margin-right: 0px
}
.xpl-main-nav--sm footer .xpl-nav-item a p, .xpl-main-nav--sm footer .xpl-nav-item button p, .xpl-main-nav--sm footer .xpl-nav-item div p, .xpl-main-nav--md footer .xpl-nav-item a p, .xpl-main-nav--md footer .xpl-nav-item button p, .xpl-main-nav--md footer .xpl-nav-item div p {
  display: none
}
.flatpickr-day.xpl-main-nav--sm footer .xpl-nav-item a p,.flatpickr-day .xpl-main-nav--sm footer .xpl-nav-item button p,.flatpickr-day .xpl-main-nav--sm footer .xpl-nav-item div p,.flatpickr-day .xpl-main-nav--md footer .xpl-nav-item a p,.flatpickr-day .xpl-main-nav--md footer .xpl-nav-item button p,.flatpickr-day .xpl-main-nav--md footer .xpl-nav-item div p{visibility:hidden}
.xpl-main-nav--sm footer .xpl-nav-item a,
        .xpl-main-nav--sm footer .xpl-nav-item button,
        .xpl-main-nav--md footer .xpl-nav-item a,
        .xpl-main-nav--md footer .xpl-nav-item button {
  margin-bottom: 0px;
  display: inline-flex
}
@keyframes modal-open {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}
@keyframes modal-close {
    from {
        opacity: 1;
    }

    to {
        opacity: 0;
    }
}
.xpl-modal .modal {
  border-radius: 1rem;
  padding: 1rem;
  --tw-text-opacity: 1;
  color: rgb(41 38 50 / var(--tw-text-opacity));

    box-shadow: 0 10px 15px -3px rgba(0 0 0 / 0.1),
        0 4px 6px -2px rgba(0 0 0 / 0.05)
}
.xpl-modal .modal--small {
  width: 400px
}
.xpl-modal .modal--medium {
  width: 600px
}
.xpl-modal .modal--large {
  width: 800px
}
.xpl-modal .modal--mobile {
  width: 350px
}
.xpl-modal .modal--open {
        opacity: 0;
        animation: modal-open 0.25s forwards;
    }
.xpl-modal .modal--close {
        opacity: 1;
        animation: modal-close 0.25s forwards;
    }
.xpl-modal .modal .modal-header {
  margin-bottom: 1rem
}
.xpl-modal .modal .modal-header .title {
  display: flex;
  align-items: center;
  justify-content: flex-start;

            font-size: var(--xpl-size-font-title-3);
            font-weight: var(--xpl-font-weight-bold)
}
.xpl-modal .modal .modal-header .title xpl-button {
  margin-left: auto
}
.xpl-modal .modal .modal-header .title .alert-icon {
  margin-right: 0.125rem;
  --tw-text-opacity: 1;
  color: rgb(194 33 15 / var(--tw-text-opacity))
}
.xpl-modal .modal .modal-header .subtitle {
  --tw-text-opacity: 1;
  color: rgb(106 109 125 / var(--tw-text-opacity));

            font-size: var(--xpl-size-font-callout);
            font-weight: var(--xpl-font-weight-normal)
}
.xpl-modal .modal .modal-body {
  margin-top: 1rem;
  margin-bottom: 1rem;

        font-size: var(--xpl-size-font-body);
        font-weight: var(--xpl-font-weight-normal)
}
.xpl-modal .modal .modal-footer {
  margin-top: 1rem;
  display: flex;
  justify-content: flex-end
}
.xpl-modal .modal .modal-footer [slot]:not(:first-child) {
  margin-left: 0.5rem
}
.xpl-modal .modal .modal-footer [slot="tertiary"] {
  margin-right: auto
}
.xpl-modal .modal .modal-footer ::slotted(*) {
        margin-left: 30px;
    }
.xpl-modal dialog::backdrop {
  background-color: transparent
}
.dark .xpl-modal .modal {
    background-color: var(--xpl-color-gray-1000);
}
.dark .xpl-modal .modal .modal-header {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity))
}
.dark .xpl-modal .modal .modal-header .title .alert-icon {
  --tw-text-opacity: 1;
  color: rgb(255 147 135 / var(--tw-text-opacity))
}
.dark .xpl-modal .modal .modal-header .subtitle {
  --tw-text-opacity: 1;
  color: rgb(153 155 168 / var(--tw-text-opacity))
}
.dark .xpl-modal .modal .modal-body {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity))
}
@media (max-width: 768px) {
    .xpl-modal dialog.modal {
    margin: auto;
    width: 350px
  }

        .xpl-modal dialog.modal .modal-footer {
    display: flex;
    flex-direction: column-reverse
  }

            .xpl-modal dialog.modal .modal-footer [slot]:not(:first-child) {
    margin-left: 0px
  }

            .xpl-modal dialog.modal .modal-footer [slot]:not(:last-child) {
    margin-top: 0.5rem
  }

            .xpl-modal dialog.modal .modal-footer [slot="tertiary"] {
    margin-right: 0px
  }

            .xpl-modal dialog.modal .modal-footer button {
    width: 100%
  }
}
.xpl-nav-item a {
    color: inherit,;
    text-decoration: none;
  }
.xpl-nav-item a p, .xpl-nav-item button p {
      margin: 0;
    }
.xpl-nav-item a svg, .xpl-nav-item button svg {
  margin-right: 0.75rem;
  height: 2rem;
  width: 2rem;
  fill: currentColor;
  --tw-text-opacity: 1;
  color: rgb(153 155 168 / var(--tw-text-opacity))
}
.xpl-nav-item a:hover svg, .xpl-nav-item a:focus svg, .xpl-nav-item a:active svg, .xpl-nav-item button:hover svg, .xpl-nav-item button:focus svg, .xpl-nav-item button:active svg {
  fill: currentColor;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity))
}
.xpl-nav-item a:hover,
    .xpl-nav-item a:focus,
    .xpl-nav-item a:active,
    .xpl-nav-item button:hover,
    .xpl-nav-item button:focus,
    .xpl-nav-item button:active {
  --tw-bg-opacity: 1;
  background-color: rgb(24 22 31 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity))
}
.xpl-nav-item a.active, .xpl-nav-item button.active {
      border-right: 4px solid var(--xpl-color-primary-dm);
    }
.xpl-nav-item a.active svg, .xpl-nav-item button.active svg {
  fill: currentColor;
  --tw-text-opacity: 1;
  color: rgb(249 145 112 / var(--tw-text-opacity))
}
.xpl-nav-item a.active, .xpl-nav-item button.active {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity))
}
.xpl-nav-item a,
  .xpl-nav-item button {
  display: flex;
  width: 100%;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  --tw-text-opacity: 1;
  color: rgb(153 155 168 / var(--tw-text-opacity));
  align-content: center;
  align-items: center;
  border-color: transparent;
  background-color: transparent
}
.xpl-main-nav--md .xpl-nav-item a,
      .xpl-main-nav--md .xpl-nav-item button,
      .xpl-main-nav--sm .xpl-nav-item a,
      .xpl-main-nav--sm .xpl-nav-item button {
  justify-content: center;
  padding-left: 0px;
  padding-right: 0px
}
.xpl-pagination {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  padding-top: 0.75rem;
  padding-bottom: 0.75rem
}
@media (min-width: 768px) {
  .xpl-pagination {
    display: flex;
    align-items: center;
    justify-content: space-between
  }
}
.xpl-pagination p {
  padding-bottom: 0.5rem;
  font-size: 0.75rem;
  line-height: 1rem;
  --tw-text-opacity: 1;
  color: rgb(60 56 71 / var(--tw-text-opacity))
}
@media (min-width: 768px) {
  .xpl-pagination p {
    padding-bottom: 0px
  }
}
.xpl-pagination span {
  font-weight: 500
}
.xpl-pagination nav {
  position: relative;
  z-index: 0;
  display: inline-flex
}
.xpl-pagination nav > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(-1px * var(--tw-space-x-reverse));
  margin-left: calc(-1px * calc(1 - var(--tw-space-x-reverse)))
}
.xpl-pagination nav {
  border-radius: 0.375rem;
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}
.xpl-pagination svg {
  height: 1.25rem;
  width: 1.25rem;
  fill: currentColor
}
.xpl-pagination .xpl-pagination-prev {
  position: relative;
  display: inline-flex;
  align-items: center;
  border-top-left-radius: 0.375rem;
  border-bottom-left-radius: 0.375rem;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(234 235 239 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(153 155 168 / var(--tw-text-opacity))
}
.xpl-pagination .xpl-pagination-prev:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(248 249 250 / var(--tw-bg-opacity))
}
.xpl-pagination .xpl-pagination-next {
  position: relative;
  display: inline-flex;
  align-items: center;
  border-top-right-radius: 0.375rem;
  border-bottom-right-radius: 0.375rem;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(234 235 239 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(153 155 168 / var(--tw-text-opacity))
}
.xpl-pagination .xpl-pagination-next:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(248 249 250 / var(--tw-bg-opacity))
}
.xpl-pagination .xpl-pagination-prev span,
.xpl-pagination .xpl-pagination-next span {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0
}
.xpl-pagination a,
.xpl-pagination button {
  position: relative;
  display: inline-flex;
  align-items: center;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(234 235 239 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(153 155 168 / var(--tw-text-opacity))
}
.xpl-pagination a:hover,
.xpl-pagination button:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(248 249 250 / var(--tw-bg-opacity))
}
.xpl-pagination-ellipsis {
  position: relative;
  display: inline-flex;
  align-items: center;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(234 235 239 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(60 56 71 / var(--tw-text-opacity))
}
.xpl-pagination .xpl-pagination-current {
  z-index: 10;
  --tw-border-opacity: 1;
  border-color: rgb(99 102 241 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(238 242 255 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(79 70 229 / var(--tw-text-opacity))
}
.xpl-pagination .xpl-pagination-current:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(238 242 255 / var(--tw-bg-opacity))
}
.xpl-pagination .xpl-pagination-show-md {
  display: none
}
.flatpickr-day.xpl-pagination .xpl-pagination-show-md{visibility:hidden}
@media (min-width: 768px) {
  .xpl-pagination .xpl-pagination-show-md {
    display: inline-flex
  }
}
/* stylelint-disable no-descending-specificity, because the rule was expecting some of the code below to appear before some code that is nested above. */
@media (max-width: 1023px) {
.xpl-secondary-nav nav::after {
        content: '';
        background: linear-gradient(270deg, #fff 13.64%, rgba(255 255 255 / 0%) 89.53%);
        position: absolute;
        top: 0px;
        bottom: 0px;
        right: 0px;
        width: 1.75rem;
        overflow: hidden
    }

        .dark .xpl-secondary-nav nav::after {
          background:
            linear-gradient(
              270deg,
              rgba(32 30 41 / 100%) 20%,
              rgb(32 30 41 / 15%) 89%
            );
        }
      }
.xpl-secondary-nav nav {
  position: relative;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity))
}
.xpl-secondary-nav nav ul::-webkit-scrollbar {
      display: none;
    }
.dark .xpl-secondary-nav nav ul {
  --tw-bg-opacity: 1;
  background-color: rgb(32 30 41 / var(--tw-bg-opacity))
}
.xpl-secondary-nav nav ul {
  display: flex;
  flex-direction: row;
  overflow-y: auto;
  white-space: nowrap;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity))
}
@media (min-width: 1024px) {
  .xpl-secondary-nav nav ul {
    flex-direction: column
  }
  .xpl-secondary-nav nav ul > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0.25rem * var(--tw-space-y-reverse))
  }
  .xpl-secondary-nav nav ul {
    white-space: normal;
    padding-left: 0px;
    padding-right: 0px
  }
}
.xpl-secondary-nav nav ul .xpl-nav-item a {
    height: 52px;
  }
.dark .xpl-secondary-nav nav ul .xpl-nav-item a {
  --tw-bg-opacity: 1;
  background-color: rgb(32 30 41 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(106 109 125 / var(--tw-text-opacity))
}
.dark .xpl-secondary-nav nav ul .xpl-nav-item a.active, .dark .xpl-secondary-nav nav ul .xpl-nav-item a:active, .dark .xpl-secondary-nav nav ul .xpl-nav-item a:focus {
  --tw-border-opacity: 1;
  border-color: rgb(249 145 112 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(24 22 31 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity))
}
.xpl-secondary-nav nav ul .xpl-nav-item a.active,
    .xpl-secondary-nav nav ul .xpl-nav-item a:active,
    .xpl-secondary-nav nav ul .xpl-nav-item a:focus {
  --tw-border-opacity: 1;
  border-color: rgb(249 145 112 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(254 246 244 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(48 45 59 / var(--tw-text-opacity))
}
.dark .xpl-secondary-nav nav ul .xpl-nav-item a:hover {
  background-color: transparent;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity))
}
.xpl-secondary-nav nav ul .xpl-nav-item a:hover {
  background-color: transparent;
  --tw-text-opacity: 1;
  color: rgb(48 45 59 / var(--tw-text-opacity))
}
.xpl-secondary-nav nav ul .xpl-nav-item a {
  border-bottom-width: 4px;
  border-right-width: 0px;
  padding-top: 1rem;
  padding-bottom: 1rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  font-size: 0.875rem;
  line-height: 1.25rem
}
@media (min-width: 1024px) {
  .xpl-secondary-nav nav ul .xpl-nav-item a {
    height: 3rem;
    border-bottom-width: 0px;
    border-right-width: 4px
  }
}
.dark .xpl-secondary-nav {
  --tw-bg-opacity: 1;
  background-color: rgb(32 30 41 / var(--tw-bg-opacity))
}
@media (min-width: 1024px) {
    .xpl-secondary-nav nav ul .xpl-nav-item a {
      width: 200px;
    }
  }
.xpl-secondary-nav {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  padding-top: 1.25rem;
  padding-bottom: 1rem
}
@media (min-width: 1024px) {
  .xpl-secondary-nav {
    display: block;
    padding: 0px
  }
}
.xpl-select .xpl-input-wrapper > button {
  background-image: url("data:image/svg+xml,%3Csvg width='12' height='8' viewBox='0 0 12 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M5.6813 7.44187L0.132167 1.93773C-0.0440556 1.76151 -0.0440556 1.47655 0.132167 1.30033L0.874551 0.557948C1.05077 0.381726 1.33573 0.381726 1.51195 0.557948L6 5.001L10.488 0.557948C10.6643 0.381726 10.9492 0.381726 11.1254 0.557948L11.8678 1.30033C12.0441 1.47655 12.0441 1.76151 11.8678 1.93773L6.3187 7.44187C6.14248 7.61809 5.85752 7.61809 5.6813 7.44187Z' fill='%23272431'/%3E%3C/svg%3E");
  background-position: calc(100% - 16px) center;
  background-repeat: no-repeat;
  height: 44px;
  outline: none !important;
  display: block;
  width: 100%;
  overflow: hidden;
  background-color: transparent;
  padding-right: 0.5rem;
  text-align: left;
  font-size: 0.875rem;
  line-height: 1.25rem;
  --tw-text-opacity: 1;
  color: rgb(106 109 125 / var(--tw-text-opacity));
}
.xpl-select.xpl-select--disabled .xpl-input-wrapper > button {
  cursor: not-allowed
}
.xpl-select.xpl-select--no-truncate .xpl-input-wrapper > button {
  position: absolute;
  right: 0px;
  height: 100%;
  width: 100%
}
.xpl-select--no-truncate .xpl-input-wrapper {
  min-height: 46px;
}
.xpl-select-value {
  pointer-events: none;
  position: absolute;
  white-space: nowrap;
  font-size: 0.875rem;
  line-height: 1.25rem;
  --tw-text-opacity: 1;
  color: rgb(106 109 125 / var(--tw-text-opacity))
}
.xpl-select--no-truncate .xpl-select-value {
  position: relative;
  white-space: normal;
  padding-right: 2rem
}
.xpl-select--no-truncate xpl-tag {
  z-index: 10;
  margin-bottom: 0.5rem
}
.xpl-select-value.has-value {
  --tw-text-opacity: 1;
  color: rgb(48 45 59 / var(--tw-text-opacity))
}
.dark .xpl-select-value {
  --tw-text-opacity: 1;
  color: rgb(153 155 168 / var(--tw-text-opacity))
}
.dark .xpl-select-value.has-value {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity))
}
.xpl-select-value--active {
  padding-top: 8px;
  pointer-events: auto;
  top: 0px;
}
.dark .xpl-select .xpl-input-wrapper > button {
  background-image: url("data:image/svg+xml,%3Csvg width='12' height='8' viewBox='0 0 12 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M5.6813 7.44187L0.132167 1.93773C-0.0440556 1.76151 -0.0440556 1.47655 0.132167 1.30033L0.874551 0.557948C1.05077 0.381726 1.33573 0.381726 1.51195 0.557948L6 5.001L10.488 0.557948C10.6643 0.381726 10.9492 0.381726 11.1254 0.557948L11.8678 1.30033C12.0441 1.47655 12.0441 1.76151 11.8678 1.93773L6.3187 7.44187C6.14248 7.61809 5.85752 7.61809 5.6813 7.44187Z' fill='white'/%3E%3C/svg%3E");
  --tw-text-opacity: 1;
  color: rgb(153 155 168 / var(--tw-text-opacity));
}
.dark .xpl-select .xpl-input-wrapper button.has-value {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity))
}
@keyframes slideInRight {
    0% {
        transform: translateX(100%);
    }

    100% {
        transform: translateX(0);
    }
}
@keyframes slideOutRight {
    0% {
        transform: translateX(0);
    }

    100% {
        transform: translateX(100%);
    }
}
@keyframes slideInBottom {
    0% {
        transform: translateY(100%);
    }

    100% {
        transform: translateY(0);
    }
}
@keyframes slideOutBottom {
    0% {
        transform: translateY(0);
    }

    100% {
        transform: translateY(100%);
    }
}
@keyframes backdropFadeIn {
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}
@keyframes backdropFadeOut {
    0% {
        opacity: 1;
    }

    100% {
        opacity: 0;
    }
}
.xpl-slideout .backdrop--open {
        animation: backdropFadeIn 0.5s forwards;
    }
.xpl-slideout .backdrop--closed {
        animation: backdropFadeOut 0.5s forwards;
    }
.xpl-slideout .slideout {
  position: fixed;
  right: 0px;
  top: 0px;
  bottom: 0px;
  z-index: 50;
  display: flex;
  height: 100vh;
  min-width: 21.5rem;
  max-width: 37.5rem;
  flex-direction: column;

        background-color: var(--xpl-color-foreground-lm);
        box-shadow: -10px 0 15px -3px rgba(0 0 0 / 0.1),
            4px 0 6px -2px rgba(0 0 0 / 0.05)
}
.xpl-slideout .slideout.slideout--open {
            animation: slideInRight 0.5s forwards;
        }
.xpl-slideout .slideout.slideout--closed {
            animation: slideOutRight 0.5s forwards;
        }
.xpl-slideout .slideout .header {
  margin: 1rem
}
.xpl-slideout .slideout .header .title {
  display: flex;
  align-items: center;
  justify-content: flex-start;

                color: var(--xpl-color-text-reverse-dm);
                font-size: var(--xpl-size-font-title-3);
                font-weight: var(--xpl-font-weight-bold)
}
.xpl-slideout .slideout .header .title xpl-button {
  margin-left: auto
}
.xpl-slideout .slideout .header .subtitle {
                color: var(--xpl-color-text-secondary-lm);
                font-size: var(--xpl-size-font-body);
                font-weight: var(--xpl-font-weight-normal);
            }
.xpl-slideout .slideout .header [slot="search"] .xpl-input-wrapper {
  margin-top: 0.75rem;
  border-radius: 9999px;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity))
}
.xpl-slideout .slideout .header [slot="search"] .xpl-input-wrapper input {
                        color: var(--xpl-color-text-primary-lm);
                    }
.xpl-slideout .slideout .content {
  flex: 1 1 0%;
  overflow-y: auto;
  padding: 1rem
}
.xpl-slideout .slideout .content.has-shadow {
                box-shadow: inset 0 4px 6px -1px rgba(0 0 0 / 0.1),
                    inset 0 2px 4px -1px rgba(0 0 0 / 0.06),
                    inset 0 -4px 6px -1px rgba(0 0 0 / 0.1),
                    inset 0 -2px 4px -1px rgba(0 0 0 / 0.06);
            }
.xpl-slideout .slideout [slot="content"] {
  display: flex;
  flex-direction: column;
  gap: 1rem
}
.xpl-slideout .slideout .footer {
  margin: 1rem;
  display: flex;
  flex-shrink: 0;
  justify-content: flex-end
}
.xpl-slideout .slideout .footer [slot]:not(:first-child) {
  margin-left: 0.5rem
}
.xpl-slideout .slideout .footer [slot="tertiary"] {
  margin-right: auto
}
.xpl-slideout .slideout .footer ::slotted(*) {
            margin-left: 30px;
        }
.xpl-slideout .slideout .divider {
  margin: 0px
}
.dark .xpl-slideout .slideout {
    background-color: var(--xpl-color-foreground-dm);
}
.dark .xpl-slideout .slideout .header .title {
            color: var(--xpl-color-text-reverse-lm);
        }
.dark .xpl-slideout .slideout .header .subtitle {
            color: var(--xpl-color-text-secondary-dm);
        }
.dark .xpl-slideout .slideout .content {
        color: var(--xpl-color-text-reverse-lm);
    }
@media (max-width: 768px) {
    .xpl-slideout .slideout {
    bottom: 0px;
    top: auto;
    height: -moz-fit-content;
    height: fit-content;
    max-height: 90%;
    width: 100%
  }

        .xpl-slideout .slideout.slideout--open {
            animation: slideInBottom 0.5s forwards;
        }

        .xpl-slideout .slideout.slideout--closed {
            animation: slideOutBottom 0.5s forwards;
        }

        .xpl-slideout .slideout .content {
    flex: 1 1 auto
  }

        .xpl-slideout .slideout .footer {
    display: flex;
    flex-direction: column-reverse
  }

            .xpl-slideout .slideout .footer [slot]:not(:first-child) {
    margin-left: 0px
  }

            .xpl-slideout .slideout .footer [slot]:not(:last-child) {
    margin-top: 0.5rem
  }

            .xpl-slideout .slideout .footer [slot="tertiary"] {
    margin-right: 0px
  }

            .xpl-slideout .slideout .footer button {
    width: 100%
  }
}
.xpl-table-container {
  overflow: auto;
  border-radius: 0.375rem;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(238 239 243 / var(--tw-border-opacity));
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}
.dark .xpl-table-container {
  --tw-border-opacity: 1;
  border-color: rgb(54 50 64 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(48 45 59 / var(--tw-bg-opacity))
}
.xpl-table {
  min-width: 100%
}
.xpl-table > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
  --tw-divide-opacity: 1;
  border-color: rgb(238 239 243 / var(--tw-divide-opacity))
}
.dark .xpl-table > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(54 50 64 / var(--tw-divide-opacity))
}
.xpl-table--abs {
  position: absolute
}
.xpl-table thead th {
  white-space: nowrap;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  text-align: left;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(153 155 168 / var(--tw-text-opacity))
}
.xpl-table-row-selected td {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(244 242 255 / var(--tw-bg-opacity)) !important
}
.xpl-table tbody tr td {
  white-space: nowrap;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  --tw-text-opacity: 1;
  color: rgb(153 155 168 / var(--tw-text-opacity))
}
.dark .xpl-table-row-selected td {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(54 50 64 / var(--tw-bg-opacity)) !important
}
.xpl-table--freeze thead th:first-child,
.xpl-table--freeze tbody td:first-child {
  border-right-width: 1px;
  position: sticky;
  left: 0px;
  z-index: 10;
  --tw-border-opacity: 1;
  border-color: rgb(238 239 243 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.xpl-table--freeze thead th:first-child {
  --tw-bg-opacity: 1;
  background-color: rgb(248 249 250 / var(--tw-bg-opacity))
}
.xpl-table tbody tr td:first-child,
.xpl-table p {
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(48 45 59 / var(--tw-text-opacity))
}
.dark .xpl-table thead th {
  --tw-text-opacity: 1;
  color: rgb(234 235 239 / var(--tw-text-opacity))
}
.dark .xpl-table tbody tr td {
  --tw-text-opacity: 1;
  color: rgb(234 235 239 / var(--tw-text-opacity))
}
.dark .xpl-table--freeze thead th:first-child {
  background-color: var(--xpl-color-background-dm);
  --tw-border-opacity: 1;
  border-color: rgb(54 50 64 / var(--tw-border-opacity));
}
.dark .xpl-table--freeze tbody td:first-child {
  background-color: var(--xpl-color-foreground-dm);
  --tw-border-opacity: 1;
  border-color: rgb(54 50 64 / var(--tw-border-opacity));
}
.xpl-table--freeze thead th:first-child::after,
.xpl-table--freeze tbody td:first-child::after {
  background:
    linear-gradient(
      90deg,
      #e4e6eb 0%,
      #e4e6eb 0.01%,
      rgba(228 230 235 / 0%) 100%
    );
  content: "";
  width: 24px;
  position: absolute;
  left: 100%;
  top: 0px;
  display: block;
  height: 100%;
  opacity: 0;
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.xpl-table--has-scrolled thead th:first-child::after,
.xpl-table--has-scrolled tbody td:first-child::after {
  opacity: 1
}
.dark .xpl-table--freeze thead th:first-child::after,
.dark .xpl-table--freeze tbody td:first-child::after {
  background:
    linear-gradient(
      90deg,
      rgba(0 0 0 / 40%) 0%,
      rgba(0 0 0 / 0%) 100%
    );
}
.xpl-table thead {
  --tw-bg-opacity: 1;
  background-color: rgb(248 249 250 / var(--tw-bg-opacity))
}
.dark .xpl-table thead {
  background-color: var(--xpl-color-background-dm);
}
.xpl-table tbody > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
  --tw-divide-opacity: 1;
  border-color: rgb(238 239 243 / var(--tw-divide-opacity))
}
.xpl-table tbody {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity))
}
.dark .xpl-table tbody {
  background-color: var(--xpl-color-foreground-dm);
}
.dark .xpl-table tbody > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(60 56 71 / var(--tw-divide-opacity))
}
.xpl-table.xpl-table--striped tbody tr:nth-child(2n) td {
  --tw-bg-opacity: 1;
  background-color: rgb(248 249 250 / var(--tw-bg-opacity))
}
.dark .xpl-table tbody tr td:first-child,
.dark .xpl-table p {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity))
}
.dark .xpl-table.xpl-table--striped tbody tr:nth-child(2n) td {
  --tw-bg-opacity: 1;
  background-color: rgb(48 45 59 / var(--tw-bg-opacity))
}
.xpl-table .wrap {
  white-space: normal
}
.xpl-table a {
  --tw-text-opacity: 1;
  color: rgb(79 70 229 / var(--tw-text-opacity))
}
.xpl-table a:hover {
  --tw-text-opacity: 1;
  color: rgb(49 46 129 / var(--tw-text-opacity))
}
.xpl-table label {
  display: flex;
  cursor: pointer;
  align-items: center
}
.xpl-table input[type="checkbox"] {
  margin-right: 1.5rem;
  cursor: pointer
}
.xpl-tabs {
  margin-bottom: 0.75rem;
  overflow-x: auto
}
.xpl-tabs nav {
  display: flex;
  min-width: 100%
}
.xpl-tabs nav > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(2rem * var(--tw-space-x-reverse));
  margin-left: calc(2rem * calc(1 - var(--tw-space-x-reverse)))
}
.xpl-tabs nav {
  border-bottom-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(238 239 243 / var(--tw-border-opacity))
}
.xpl-tabs a,
.xpl-tabs button {
  display: flex;
  white-space: nowrap;
  border-bottom-width: 2px;
  border-color: transparent;
  padding-top: 1rem;
  padding-bottom: 1rem;
  padding-left: 0.25rem;
  padding-right: 0.25rem;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(153 155 168 / var(--tw-text-opacity))
}
.xpl-tabs a:hover,
.xpl-tabs button:hover {
  --tw-border-opacity: 1;
  border-color: rgb(238 239 243 / var(--tw-border-opacity));
  --tw-text-opacity: 1;
  color: rgb(60 56 71 / var(--tw-text-opacity))
}
.xpl-tabs a span,
.xpl-tabs button span {
  margin-left: 0.75rem;
  border-radius: 9999px;
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
  padding-left: 0.625rem;
  padding-right: 0.625rem;
  font-size: 0.625rem;
  line-height: 0.875rem;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(48 45 59 / var(--tw-text-opacity))
}
.xpl-tabs a.current,
.xpl-tabs button.current {
  --tw-border-opacity: 1;
  border-color: rgb(99 102 241 / var(--tw-border-opacity));
  --tw-text-opacity: 1;
  color: rgb(79 70 229 / var(--tw-text-opacity))
}
.xpl-tabs a.current span,
.xpl-tabs button.current span {
  --tw-bg-opacity: 1;
  background-color: rgb(224 231 255 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(79 70 229 / var(--tw-text-opacity))
}
.xpl-tag-container {
  position: relative;
  display: inline-flex
}
button.xpl-tag {
  border-color: var(--xpl-color-secondary-lm);
  padding: 2px 28px 2px 10px;
  margin-right: -0.25rem;
  border-radius: 9999px;
  border-width: 1px;
  font-size: 0.875rem;
  line-height: 1.25rem;
  --tw-text-opacity: 1;
  color: rgb(48 45 59 / var(--tw-text-opacity));
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.xpl-tag-container:hover button.xpl-tag {
  --tw-bg-opacity: 1;
  background-color: rgb(235 229 255 / var(--tw-bg-opacity))
}
.dark .xpl-tag {
  border-color: var(--xpl-color-secondary-dm);
  --tw-bg-opacity: 1;
  background-color: rgb(48 45 59 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.dark .xpl-tag-container:hover button.xpl-tag {
  --tw-border-opacity: 1;
  border-color: rgb(235 229 255 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(60 56 71 / var(--tw-bg-opacity))
}
button.xpl-tag__close {
  right: 18px;
  top: -1px;
  position: relative;
  height: 100%;
  font-size: 1.25rem;
  line-height: 1.75rem;
  --tw-text-opacity: 1;
  color: rgb(106 109 125 / var(--tw-text-opacity));
}
.dark button.xpl-tag__close {
  --tw-text-opacity: 1;
  color: rgb(153 155 168 / var(--tw-text-opacity))
}
.xpl-toggle-container {
  margin-bottom: 1.5rem;
  display: flex;
  flex-wrap: wrap
}
.xpl-toggle {
  --tw-ring-color: var(--xpl-color-secondary-lm);

  border-radius: 12px;
  border-color: #d1d5db;
  height: 24px;
  top: 2px;
  transition-property: background-color;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
  width: 44px;
  position: relative;
  flex-shrink: 0;
  cursor: pointer;
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  --tw-bg-opacity: 1;
  background-color: rgb(225 226 232 / var(--tw-bg-opacity));
}
.xpl-toggle:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(153 155 168 / var(--tw-bg-opacity))
}
.xpl-toggle:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-offset-width: 2px
}
.xpl-toggle-container label {
  cursor: pointer;
  font-size: 0.875rem;
  line-height: 1.25rem;
  --tw-text-opacity: 1;
  color: rgb(48 45 59 / var(--tw-text-opacity))
}
/* label (to the right of toggle) */
.xpl-toggle + label {
  margin-top: 0.25rem;
  cursor: pointer;
  padding-left: 1rem;
  padding-right: 1rem;
  vertical-align: middle;
  font-size: 0.875rem;
  line-height: 1.25rem
}
.xpl-toggle--small + label {
  margin-top: 0px
}
.xpl-toggle-container--disabled label {
  color: var(--xpl-color-text-secondary-lm);
  cursor: not-allowed;
}
.dark .xpl-toggle-container label {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity))
}
/* heading */
.xpl-toggle-container label:first-child {
  display: block;
  width: 100%;
  padding-bottom: 0.25rem
}
/* description */
.xpl-toggle-container small {
  display: block;
  font-size: 0.75rem;
  line-height: 1rem;
  --tw-text-opacity: 1;
  color: rgb(153 155 168 / var(--tw-text-opacity))
}
.dark .xpl-toggle {
  --tw-ring-offset-color: var(--xpl-color-gray-900);
  --tw-ring-color: var(--xpl-color-secondary-dm);
  --tw-bg-opacity: 1;
  background-color: rgb(106 109 125 / var(--tw-bg-opacity));
}
.dark .xpl-toggle:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(153 155 168 / var(--tw-bg-opacity))
}
.xpl-toggle::after {
  background-color: #fff;
  background-image: url("data:image/svg+xml,%3Csvg width='8' height='8' viewBox='0 0 8 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4 4L7 7M1 7L4 4L1 7ZM4 4L7 1L4 4ZM4 4L1 1L4 4Z' stroke='%236A6D7D' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A");
  background-position: 50% 50%;
  background-repeat: no-repeat;
  border-radius: 50%;
  box-shadow: 0 1px 3px 0 #0000001a;
  content: "";
  display: block;
  height: 20px;
  position: absolute;
  top: 2px;
  left: 2px;
  width: 20px;
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.dark .xpl-toggle + label {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity))
}
.xpl-toggle:checked {
  background-color: var(--xpl-color-secondary-lm);
}
.xpl-toggle-container--disabled .xpl-toggle,
.xpl-toggle-container--disabled .xpl-toggle:hover {
  cursor: not-allowed;
  --tw-bg-opacity: 1;
  background-color: rgb(238 239 243 / var(--tw-bg-opacity))
}
.dark .xpl-toggle:checked {
  background-color: var(--xpl-color-secondary-dm);
}
.dark .xpl-toggle-container--disabled .xpl-toggle {
  background-color: var(--xpl-color-action-disabled-dm);
}
.xpl-toggle:checked:hover {
  background-color: var(--xpl-color-secondary-hover-lm);
}
.xpl-toggle:checked::after {
  background-image: url("data:image/svg+xml,%3Csvg width='11' height='8' viewBox='0 0 11 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M10 1L4 7L1 4' stroke='%236923F4' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A");
  transform: translateX(20px);
}
.xpl-toggle:disabled::after {
  --tw-bg-opacity: 1;
  background-color: rgb(248 249 250 / var(--tw-bg-opacity))
}
.xpl-toggle:checked:hover::after {
  background-image: url("data:image/svg+xml,%3Csvg width='11' height='8' viewBox='0 0 11 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M10 1L4 7L1 4' stroke='%234D1AB2' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A");
}
.xpl-toggle:disabled:checked,
.xpl-toggle:disabled:checked:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(221 209 255 / var(--tw-bg-opacity))
}
.dark .xpl-toggle:checked:hover {
  background-color: var(--xpl-color-secondary-hover-dm);
}
.dark .xpl-toggle:disabled:checked,
.dark .xpl-toggle:disabled:checked:hover {
  background-color: var(--xpl-color-action-disabled-dm);
}
.xpl-toggle:disabled:checked::after {
  background-image: url("data:image/svg+xml,%3Csvg width='11' height='8' viewBox='0 0 11 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M10 1L4 7L1 4' stroke='%23A480FF' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A");
}
.dark .xpl-toggle:disabled::after {
  background-image: url("data:image/svg+xml,%3Csvg width='8' height='8' viewBox='0 0 8 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4 4L7 7M1 7L4 4L1 7ZM4 4L7 1L4 4ZM4 4L1 1L4 4Z' stroke='%23272431' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A");
  --tw-bg-opacity: 1;
  background-color: rgb(106 109 125 / var(--tw-bg-opacity));
}
.dark .xpl-toggle:disabled:checked::after {
  background-image: url("data:image/svg+xml,%3Csvg width='11' height='8' viewBox='0 0 11 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M10 1L4 7L1 4' stroke='%23272431' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A");
}
.xpl-toggle--small {
  border-radius: 8px;
  height: 16px;
  width: 28px;
}
.xpl-toggle--small::after {
  background-position: center calc(50% + 0.5px);
  background-size: 50% auto;
  height: 12px;
  width: 12px;
}
.xpl-toggle--small:checked::after {
  background-size: 60% auto;
  transform: translateX(12px);
}
.xpl-utility-bar {
  background-color: var(--xpl-color-gray-0);
  color: var(--xpl-color-gray-500);
}
.xpl-utility-bar ul > *, .xpl-utility-bar nav > *, .xpl-utility-bar xpl-breadcrumbs > * {
  display: grid;
  align-content: center
}
.xpl-utility-bar ul:nth-child(2) > *, .xpl-utility-bar nav:nth-child(2) > *, .xpl-utility-bar xpl-breadcrumbs:nth-child(2) > * {
  margin-left: 0.5rem
}
.xpl-utility-bar ul:nth-child(2), .xpl-utility-bar nav:nth-child(2), .xpl-utility-bar xpl-breadcrumbs:nth-child(2) {
  justify-self: end
}
.xpl-utility-bar ul:first-child > *, .xpl-utility-bar nav:first-child > *, .xpl-utility-bar xpl-breadcrumbs:first-child > * {
  margin-right: 0.5rem
}
.xpl-utility-bar ul:first-child, .xpl-utility-bar nav:first-child, .xpl-utility-bar xpl-breadcrumbs:first-child {
  justify-self: start
}
.xpl-utility-bar ul,
  .xpl-utility-bar nav,
  .xpl-utility-bar xpl-breadcrumbs {
  display: grid;
  grid-auto-flow: column;
  align-content: center;
  align-items: center
}
.xpl-utility-bar div:first-child {
  display: flex
}
.xpl-utility-bar {
  display: grid;
  grid-auto-flow: column;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem
}
@media (min-width: 640px) {
  .xpl-utility-bar {
    padding-left: 1.5rem;
    padding-right: 1.5rem
  }
}
.dark .xpl-utility-bar {
  background-color: var(--xpl-color-background-2-dm);
  color: var(--xpl-color-gray-300);
}
.xpl-utility-bar__nav-control {
  align-items: center;
  display: flex;
}
.xpl-utility-nav__bars {
  color: var(--xpl-color-text-primary-lm);
  fill: currentcolor;
  height: 16px;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.dark .xpl-utility-nav__bars {
  color: var(--xpl-color-text-primary-dm);
}
